/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum FusionSharedEnumsUserType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value100 = 100,
}

/** @format int32 */
export enum FusionSharedEnumsUserStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FusionSharedEnumsUserCapabilityStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FusionSharedEnumsTutorStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FusionSharedEnumsTimeSlotState {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum FusionSharedEnumsSubscriptionType {
  Value2 = 2,
  Value4 = 4,
  Value6 = 6,
}

/** @format int32 */
export enum FusionSharedEnumsSubscriptionStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FusionSharedEnumsSnappPayUsageRestriction {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsSignupType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum FusionSharedEnumsSaleType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsPspType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
}

/** @format int32 */
export enum FusionSharedEnumsPlanType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FusionSharedEnumsPlacementType {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsPlacementStatus {
  Value4 = 4,
  Value8 = 8,
  Value16 = 16,
  Value32 = 32,
}

/** @format int32 */
export enum FusionSharedEnumsPlacementResultStatus {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsPlacementRequestStudentSubscriptionType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsPlacementRequestCreatorType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FusionSharedEnumsNpsType {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsNpsState {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsNewFLowStep {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum FusionSharedEnumsMeetingType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FusionSharedEnumsMeetingStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum FusionSharedEnumsMeetingInviteeStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsMediaUsage {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FusionSharedEnumsInterruptReason {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
}

/** @format int32 */
export enum FusionSharedEnumsGender {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FusionSharedEnumsFileType {
  Value0 = 0,
}

/** @format int32 */
export enum FusionSharedEnumsEmployee {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum FusionSharedEnumsCourseType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FusionSharedEnumsBusinessDay {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum FusionSharedEnumsBookingRequestState {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FusionSharedDtosBookingTimeSlotEndTimeSlotType {
  Value0 = 0,
  Value1 = 1,
}

export interface TypeFAnonymousType1152SystemStringSystemString {
  routeParameter?: string | null;
  queryStringParameter?: string | null;
}

export interface BookingHandlersCommandsCreateNpsCommand {
  type?: FusionSharedEnumsNpsType;
  title?: string | null;
  subTitle?: string | null;
  /** @format date-time */
  startedAt?: string;
  /** @format date-time */
  endedAt?: string;
  state?: FusionSharedEnumsNpsState;
}

export interface BookingHandlersCommandsCreateNpsFormCommand {
  objectId?: string | null;
  /** @format float */
  rating?: number;
  description?: string | null;
  advantages?: string[] | null;
  disadvantages?: string[] | null;
  /** @format uuid */
  businessUserId?: string | null;
}

export interface BookingHandlersCommandsCreateNpsPostponeCommand {
  objectId?: string | null;
  /** @format uuid */
  parentId?: string;
}

export interface BookingHandlersCommandsNotifyNpsCommand {
  /** @format uuid */
  npsId?: string;
}

export interface BookingHandlersCommandsSetupCommand {
  data?: string | null;
  modifiedBy?: string | null;
  secretCode?: string | null;
}

export type BookingManagementCQRSQueriesGetNotifyNpsHistoriesQuery = object;

export interface BookingManagementCQRSQueriesGetNpsListByBusinessUserQuery {
  userId?: string[] | null;
  studentId?: string[] | null;
  courses?: string[] | null;
  userCapabilityStatus?: FusionSharedEnumsUserCapabilityStatus[] | null;
  planType?: FusionSharedEnumsPlanType[] | null;
  phoneNumber?: string | null;
}

export interface BookingManagementHandlersAcceptBookingCommand {
  description?: string | null;
  /** @format uuid */
  reviewerId?: string;
  /** @format uuid */
  bookingId?: string;
}

export interface BookingManagementHandlersAssignTimeSlotToStudentCommand {
  /** @format uuid */
  userSubscriptionId?: string;
  /** @format int32 */
  timeSlotId?: number;
  /** @format uuid */
  businessUserId?: string;
  forceReassignIfHasActiveTimeSlot?: boolean;
}

export interface BookingManagementHandlersCreateNewBookingByTutorCommand {
  description?: string | null;
  /** @format uuid */
  tutorId?: string;
  dates?: FusionSharedDtosBookingCreateNewBookingByTutorDateDto[] | null;
}

export interface BookingManagementHandlersCreateTimeSlotCommand {
  /** @format uuid */
  tutorId?: string;
  /** @format int32 */
  requiredEconomyTimeSlotCount?: number | null;
  economyCourses?: string[] | null;
  premiumCourses?: string[] | null;
  trialCourses?: string[] | null;
  studentGender?: FusionSharedEnumsGender;
}

export interface BookingManagementHandlersEndTimeSlotGroupCommand {
  /** @format uuid */
  timeSlotId?: string;
  type?: FusionSharedDtosBookingTimeSlotEndTimeSlotType;
  endReasonDescription?: string | null;
  ignoreUpdateUserCourses?: boolean;
  /** @format uuid */
  businessUserId?: string;
}

export interface BookingManagementHandlersFilterTimeSlotQuery {
  /** @format uuid */
  userSubscriptionId?: string;
  loadAllTimeSlotInDay?: boolean;
  /** @format int32 */
  tutorRank?: number | null;
}

export interface BookingManagementHandlersGetAvailableTutorForTimeSlotListQuery {
  /** @format uuid */
  timeSlotId?: string;
}

export type BookingManagementHandlersGetCoursesQuery = object;

export interface BookingManagementHandlersGetTimeSlotListQuery {
  search?: string | null;
  studentName?: string | null;
  courses?: string[] | null;
  /** @format date-time */
  startTimeInWeek?: string | null;
  states?: FusionSharedEnumsTimeSlotState[] | null;
  businessDays?: FusionSharedEnumsBusinessDay[] | null;
}

export interface BookingManagementHandlersGetTutorsWithAdvancedFiltersQuery {
  search?: string | null;
  /** @format date-time */
  lastBookingCreatedFrom?: string | null;
  /** @format date-time */
  lastBookingCreatedTo?: string | null;
  lastBookingState?: FusionSharedEnumsBookingRequestState[] | null;
  hasNoRequest?: boolean | null;
  courseIds?: string[] | null;
  courseType?: FusionSharedEnumsCourseType;
  studentGenders?: FusionSharedEnumsGender[] | null;
  genders?: FusionSharedEnumsGender[] | null;
}

export interface BookingManagementHandlersNpsFakerCommand {
  /** @format int32 */
  count?: number | null;
}

export interface BookingManagementHandlersRejectBookingCommand {
  description?: string | null;
  /** @format uuid */
  reviewerId?: string;
  /** @format uuid */
  bookingId?: string;
}

export interface BookingManagementHandlersSyncTimeSlotWithMoodleGroupCommand {
  timeSlotId?: string[] | null;
  ignoreNotifyTutor?: boolean;
}

export interface BookingManagementHandlersSyncTutorsWithMoodleCommand {
  /** @format date-time */
  syncIfUpdatedAfterDateTime?: string | null;
  userName?: string | null;
}

export interface BookingManagementHandlersTimeSlotFakerCommand {
  /** @format int32 */
  count?: number | null;
}

export interface BookingManagementHandlersTutorSeedCommand {
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  startIdFrom?: number | null;
}

export interface BookingManagementHandlersUnAssignTimeSlotStudentCommand {
  /** @format int32 */
  timeSlotUserSubscriptionId?: number;
  /** @format uuid */
  businessUserId?: string;
}

export interface BookingManagementHandlersUpdateTimeSlotTimeCommand {
  /** @format uuid */
  timeSlotId?: string;
  businessDay: FusionSharedEnumsBusinessDay;
  /** @format date-time */
  startedAt: string;
  /** @format uuid */
  businessUserId?: string;
}

export interface BookingManagementHandlersUpdateTimeSlotTutorCommand {
  /** @format uuid */
  timeSlotId?: string;
  /** @format uuid */
  tutorId?: string;
  /** @format uuid */
  businessUserId?: string;
}

export interface BookingManagementHandlersUpdateTutorCommand {
  /** @format uuid */
  tutorId?: string;
  status?: FusionSharedEnumsTutorStatus;
  /** @format float */
  initialRating?: number | null;
}

export interface FusionApiModelsUIGallery {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  modifiedOn?: string;
  isArchived?: boolean;
  title?: string | null;
  url?: string | null;
  href?: string | null;
  mediaType?: FusionSharedEnumsFileType;
  mediaUsage?: FusionSharedEnumsMediaUsage;
}

export interface FusionServerDtosIntegrationUserForCrmResponse {
  students?: FusionServerDtosIntegrationUserForCrmResponseStudentsDto[] | null;
  /** @format int32 */
  totalCounts?: number;
}

export interface FusionServerDtosIntegrationUserForCrmResponseStudentCourseDto {
  /** @format uuid */
  id?: string;
  moodleId?: string | null;
  name?: string | null;
  topicName?: string | null;
}

export interface FusionServerDtosIntegrationUserForCrmResponseStudentTimeSlotDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  endedAt?: string | null;
  day?: string | null;
  /** @format date-time */
  enteredTime?: string;
  /** @format date-time */
  exitedTime?: string;
  timeInformation?: string | null;
  /** @format uuid */
  tutorId?: string;
  tutorName?: string | null;
  /** @format date-time */
  timeSlotLastModifiedOn?: string;
  course?: FusionServerDtosIntegrationUserForCrmResponseStudentCourseDto;
}

export interface FusionServerDtosIntegrationUserForCrmResponseStudentsDto {
  /** @format uuid */
  id?: string;
  phoneNumber?: string | null;
  fullName?: string | null;
  parentPhoneNumber?: string | null;
  parentFullName?: string | null;
  /** @format uuid */
  parentId?: string | null;
  grade?: string | null;
  gender?: string | null;
  timeSlot?: FusionServerDtosIntegrationUserForCrmResponseStudentTimeSlotDto;
  /** @format int32 */
  totalTransactionCount?: number | null;
  /** @format double */
  transactionPayableAmountSum?: number | null;
  capabilityStatus?: string | null;
  status?: FusionSharedEnumsUserStatus;
  signupType?: FusionSharedEnumsSignupType;
  /** @format date-time */
  userLastModifiedOn?: string | null;
  /** @format date-time */
  transactionLastModifiedOn?: string | null;
  /** @format date-time */
  lastTransaction?: string | null;
  lastTransactionInJalali?: string | null;
  lastUsedPromotion?: string | null;
  /** @format double */
  lastUsedPromotionAmount?: number | null;
  /** @format double */
  lastTransactionPayableAmount?: number | null;
  lastPlanType?: string | null;
  currentPlanType?: string | null;
  subscriptionExpireAtInJalali?: string | null;
  /** @format date-time */
  subscriptionExpireAt?: string | null;
  /** @format date-time */
  userCreatedOn?: string | null;
  course?: FusionServerDtosIntegrationUserForCrmResponseStudentCourseDto;
  isPhoneNumberConfirmed?: boolean | null;
}

export interface FusionServerServicesReportStudentSubscriptionRangeRequestQuery {
  token?: string | null;
  students?:
    | FusionServerServicesReportStudentSubscriptionRangeRequestQueryItem[]
    | null;
}

export interface FusionServerServicesReportStudentSubscriptionRangeRequestQueryItem {
  /** @format uuid */
  userId?: string;
  /** @format date-time */
  startDateOffset?: string;
  /** @format date-time */
  endDateOffset?: string;
}

export interface FusionSharedDtosAccountAddPasswordRequestDto {
  /** @minLength 1 */
  userName: string;
  /** @minLength 6 */
  password: string;
  /** @minLength 6 */
  confirmPassword: string;
}

export interface FusionSharedDtosAccountAdminResetPasswordRequestDto {
  /** @format uuid */
  userId?: string;
  /** @minLength 6 */
  password: string;
  /** @minLength 6 */
  confirmPassword: string;
}

export interface FusionSharedDtosAccountCampaignSignUpInputDto {
  /**
   * @format tel
   * @minLength 1
   */
  phoneNumber: string;
  userName?: string | null;
  fullName?: string | null;
  /** @minLength 1 */
  childFullName: string;
  childGender?: FusionSharedEnumsGender;
  initialAgeCategoryCode?: string | null;
  userTypeAsString?: string | null;
  utm?: FusionSharedDtosAccountUtmDto;
  isTrial?: boolean;
}

export interface FusionSharedDtosAccountCampaignSignUpOutputDto {
  callbackUrl?: string | null;
}

export interface FusionSharedDtosAccountChangePasswordRequestDto {
  /** @minLength 1 */
  currentPassword: string;
  /** @minLength 1 */
  newPassword: string;
  /** @minLength 1 */
  confirmPassword: string;
  /** @format uuid */
  userId?: string;
}

export interface FusionSharedDtosAccountConfirmEmailRequestDto {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  token: string;
}

export interface FusionSharedDtosAccountEditUserDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  currentUserId?: string;
  /** @minLength 1 */
  fullName: string;
  gender: FusionSharedEnumsGender;
  /** @format date-time */
  birthDate?: string | null;
  nationalCode?: string | null;
  /** @format uuid */
  initialAgeCategoryId: string;
  ageCategoryId?: string | null;
  isCompleteRegistration?: boolean;
  parentFullName?: string | null;
  isFamiliarWithProgramming?: boolean | null;
}

export interface FusionSharedDtosAccountEditUserFullNameDto {
  /** @format uuid */
  currentUserId?: string;
  /** @minLength 1 */
  fullName: string;
}

export interface FusionSharedDtosAccountEditUserNationalCodeDto {
  /** @format uuid */
  currentUserId?: string;
  /** @minLength 1 */
  nationalCode: string;
}

export interface FusionSharedDtosAccountOtpTokenRequestDto {
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  userName: string;
}

export interface FusionSharedDtosAccountRefreshTokenRequestDto {
  /** @minLength 1 */
  refreshToken: string;
}

export interface FusionSharedDtosAccountRefreshTokenResopnseDto {
  accessToken?: string | null;
  /** @format int64 */
  expiresIn?: number;
  refreshToken?: string | null;
}

export interface FusionSharedDtosAccountResetPasswordRequestDto {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @minLength 1 */
  token: string;
  /** @minLength 6 */
  password: string;
  /** @minLength 6 */
  confirmPassword: string;
}

export interface FusionSharedDtosAccountSendConfirmationEmailRequestDto {
  /** @minLength 1 */
  email: string;
  userType: FusionSharedEnumsUserType;
  userTypeAsString?: string | null;
}

export interface FusionSharedDtosAccountSendOtpTokenRequestDto {
  /** @minLength 1 */
  userName: string;
  secoundServer?: boolean;
}

export interface FusionSharedDtosAccountSendResetPasswordEmailRequestDto {
  /** @minLength 1 */
  email: string;
}

export interface FusionSharedDtosAccountSignInRequestDto {
  /** @minLength 1 */
  userName: string;
  /** @minLength 6 */
  password: string;
  rememberMe?: boolean | null;
}

export interface FusionSharedDtosAccountSignInResponseDto {
  accessToken?: string | null;
  /** @format int64 */
  expiresIn?: number;
  refreshToken?: string | null;
  lastStep?: FusionSharedEnumsNewFLowStep;
  canSeeNewFlow?: boolean;
  signupType?: FusionSharedEnumsSignupType;
  redirectUrl?: string | null;
  userType?: string | null;
}

export interface FusionSharedDtosAccountSignUpRequestDto {
  /** @minLength 1 */
  userName: string;
  /** @format email */
  email?: string | null;
  /** @format tel */
  phoneNumber?: string | null;
  password?: string | null;
  fullName?: string | null;
  userType: FusionSharedEnumsUserType;
  signupType?: FusionSharedEnumsSignupType;
  userTypeAsString?: string | null;
}

export interface FusionSharedDtosAccountUserDto {
  /** @format uuid */
  id?: string;
  userName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  nationalCode?: string | null;
  password?: string | null;
  fullName?: string | null;
  displayName?: string | null;
  gender?: FusionSharedEnumsGender;
  /** @format date-time */
  birthDate?: string | null;
  /** @format uuid */
  initialAgeCategoryId?: string | null;
  profileImageName?: string | null;
  /** @format date-time */
  expirationDate?: string | null;
  capabilityStatus?: FusionSharedEnumsUserCapabilityStatus;
  /** @format uuid */
  utmId?: string | null;
  /** @format uuid */
  parentUserId?: string | null;
  canSeeEconomy?: boolean;
  canSeeTrial?: boolean;
  canAddStudent?: boolean;
  userPlanType?: FusionSharedEnumsPlanType;
  /** @format date-time */
  createdOn?: string;
  parentFullName?: string | null;
  parentSignupType?: FusionSharedEnumsSignupType;
  isCompleteRegistration?: boolean;
}

export interface FusionSharedDtosAccountUtmDto {
  source?: string | null;
  medium?: string | null;
  campaign?: string | null;
  term?: string | null;
  content?: string | null;
  ma?: string | null;
}

export interface FusionSharedDtosBookingCreateNewBookingByTutorDateDto {
  day?: FusionSharedEnumsBusinessDay;
  times?: FusionSharedDtosBookingCreateNewBookingByTutorDateTimeDto[] | null;
}

export interface FusionSharedDtosBookingCreateNewBookingByTutorDateTimeDto {
  /** @format date-time */
  enteredDateTime?: string | null;
  /** @format date-time */
  exitedDateTime?: string | null;
}

export interface FusionSharedDtosBookingTimeSlotChangeMinCapacityRequest {
  /** @format uuid */
  timeSlotId?: string;
  /** @format int32 */
  minCapacity?: number;
}

export interface FusionSharedDtosBookingTimeSlotReAssignStudentRequest {
  /** @format uuid */
  userSubscriptionId?: string;
  /** @format int32 */
  timeSlotId?: number;
}

export interface FusionSharedDtosDirectDebitDirectDebitAuthorizationDto {
  id?: string | null;
  customerUuid?: string | null;
  token?: string | null;
  bankCode?: string | null;
  callbackUrl?: string | null;
  /** @format int32 */
  count?: number;
  /** @format double */
  limit?: number;
  mobile?: string | null;
  name?: string | null;
  email?: string | null;
  nationalCode?: string | null;
  /** @format date-time */
  expirationDate?: string;
  status?: string | null;
  payerAccount?: FusionSharedDtosDirectDebitDirectDebitPayerAccountDto;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  revokedAt?: string;
}

export interface FusionSharedDtosDirectDebitDirectDebitBankDto {
  code?: string | null;
  name?: string | null;
  hasDirectDebitAbility?: boolean;
  hasRefundAbility?: boolean;
  isHealthyOnDirectDebit?: boolean;
  /** @format int32 */
  maxWithdrawalAmount?: number;
  /** @format int32 */
  maxWithdrawalAmountPerTransaction?: number;
  withdrawalAmountCurrency?: string | null;
  /** @format int32 */
  maxWithdrawalDailyCount?: number | null;
  /** @format int32 */
  maxMandateValidityDuration?: number;
  mandateValidityDurationUnit?: string | null;
  payerAuthenticationType?: string | null;
  logo?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitGetAuthorizeListRequestDto {
  authorizationId?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitGetAuthorizeListResponseDto {
  items?: FusionSharedDtosDirectDebitDirectDebitAuthorizationDto[] | null;
}

export type FusionSharedDtosDirectDebitDirectDebitGetBankRequestDto = object;

export interface FusionSharedDtosDirectDebitDirectDebitGetBankResponseDto {
  items?: FusionSharedDtosDirectDebitDirectDebitBankDto[] | null;
}

export type FusionSharedDtosDirectDebitDirectDebitGetParentCurrentAuthorizationRequestDto =
  object;

export interface FusionSharedDtosDirectDebitDirectDebitGetParentCurrentAuthorizationResponseDto {
  authorization?: FusionSharedDtosDirectDebitDirectDebitAuthorizationDto;
}

export type FusionSharedDtosDirectDebitDirectDebitGetParentInformationRequestDto =
  object;

export interface FusionSharedDtosDirectDebitDirectDebitGetParentInformationResponseDto {
  isActive?: boolean;
  hasActiveContract?: boolean;
  /** @format int32 */
  minMonth?: number;
  /** @format int32 */
  minCount?: number;
  /** @format double */
  minLimit?: number;
}

export type FusionSharedDtosDirectDebitDirectDebitGetWithdrawalListRequestDto =
  object;

export interface FusionSharedDtosDirectDebitDirectDebitGetWithdrawalListResponseDto {
  items?: FusionSharedDtosDirectDebitDirectDebitWithdrawalDto[] | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitPayerAccountDto {
  accountNumber?: string | null;
  pan?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitPostNewAuthorizeRequestDto {
  bankCode?: string | null;
  /** @format int32 */
  month?: number;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  limit?: number;
  name?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitPostNewAuthorizeResponseDto {
  redirectUrl?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitPostRevokeAuthorizeRequestDto {
  authorizationId?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitPostRevokeAuthorizeResponseDto {
  isOk?: boolean;
  message?: string | null;
}

export interface FusionSharedDtosDirectDebitDirectDebitWithdrawalDto {
  id?: string | null;
  authorizationId?: string | null;
  /** @format int32 */
  retryCount?: number;
  /** @format int32 */
  maxRetryCount?: number;
  gatewayTransactionId?: string | null;
  refundId?: string | null;
  amount?: string | null;
  wageAmount?: string | null;
  paymentNumber?: string | null;
  payerAccount?: FusionSharedDtosDirectDebitDirectDebitPayerAccountDto;
  trackId?: string | null;
  status?: string | null;
  description?: string | null;
  /** @format date-time */
  withdrawalDate?: string;
  notifyUrl?: string | null;
  /** @format int32 */
  isInstant?: number;
  errorCode?: string | null;
  errorMessage?: string | null;
}

export type FusionSharedDtosDirectUserDirectSignupResponseDto = object;

export interface FusionSharedDtosDirectUserDirectUserProfileResponseDto {
  fullName?: string | null;
  userName?: string | null;
  phoneNumber?: string | null;
  step?: FusionSharedEnumsNewFLowStep;
  canSeeNewFlow?: boolean;
  signupType?: FusionSharedEnumsSignupType;
  students?:
    | FusionSharedDtosDirectUserDirectUserProfileResponseStudentDto[]
    | null;
}

export interface FusionSharedDtosDirectUserDirectUserProfileResponseStudentDto {
  /** @format uuid */
  id?: string;
  fullName?: string | null;
  isFamiliarWithProgramming?: boolean | null;
  gender?: FusionSharedEnumsGender;
  /** @format date-time */
  birthDate?: string | null;
  /** @format uuid */
  initialAgeCategoryId?: string | null;
  isSignupCompleted?: boolean;
  isSnappPayActive?: boolean;
}

export interface FusionSharedDtosDirectUserDirectUserSignupRequestDto {
  /** @minLength 1 */
  phoneNumber: string;
  /** @minLength 1 */
  childFullName: string;
  /** @minLength 1 */
  fullName: string;
  utm?: FusionSharedDtosAccountUtmDto;
}

export interface FusionSharedDtosDirectUserDirectUserUpdateLastStepRequestDto {
  step?: FusionSharedEnumsNewFLowStep;
}

export interface FusionSharedDtosDirectUserStudentBulkInsertRequestDto {
  students?:
    | FusionSharedDtosDirectUserStudentBulkInsertRequestStudentDto[]
    | null;
  allowIfExists?: boolean;
  allowIfHasSubscription?: boolean;
}

export interface FusionSharedDtosDirectUserStudentBulkInsertRequestStudentDto {
  parentPhoneNumber?: string | null;
  parentFullName?: string | null;
  fullName?: string | null;
  ageCategoryTitle?: string | null;
  subscriptionPlanTitle?: string | null;
  subscriptionPlanSubTitle?: string | null;
  gender?: FusionSharedEnumsGender;
  /** @format date-time */
  birthDate?: string | null;
  nationalCode?: string | null;
  offlinePaymentId?: string | null;
  isFamiliarWithProgramming?: boolean | null;
  signupType?: FusionSharedEnumsSignupType;
}

export interface FusionSharedDtosDirectUserStudentBulkInsertResponseDto {
  existingUsers?: string[] | null;
  addedUsers?: string[] | null;
  errors?: Record<string, string[]>;
}

export interface FusionSharedDtosDirectUserUndoStudentBulkInsertResponseDto {
  existingUsers?: string[] | null;
  deletedUsers?: string[] | null;
  errors?: Record<string, string[]>;
}

export interface FusionSharedDtosGalleryBannerOutputDto {
  /** @format uuid */
  id?: string;
  title?: string | null;
  url?: string | null;
  href?: string | null;
}

export interface FusionSharedDtosGalleryGalleryOutputDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  modifiedOn?: string;
  title?: string | null;
  url?: string | null;
  mediaType?: FusionSharedEnumsFileType;
  mediaUsage?: FusionSharedEnumsMediaUsage;
}

export interface FusionSharedDtosInterruptsInterruptInputDto {
  /** @minItems 1 */
  interruptReasons: number[];
  /** @format int32 */
  employee: number;
  isUrgent?: boolean;
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  durationInDay: number;
  /** @format uuid */
  userId?: string | null;
  /** @format uuid */
  userSubscriptionId?: string | null;
  isNoticed?: boolean;
  /** @minLength 1 */
  description: string;
}

export interface FusionSharedDtosInterruptsInterruptOutputDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  modifiedOn?: string;
  isArchived?: boolean;
  interruptReasons?: FusionSharedEnumsInterruptReason[] | null;
  employee?: FusionSharedEnumsEmployee;
  isUrgent?: boolean;
  /** @format int32 */
  durationInDay?: number;
  userFullName?: string | null;
  /** @format uuid */
  userId?: string;
  isNoticed?: boolean;
  description?: string | null;
  /** @format date-time */
  newExpierDateTime?: string;
  /** @format date-time */
  lastExpierDateTime?: string;
}

export interface FusionSharedDtosInvoiceCreatePaymentLinkByUserRequest {
  subscriptionPlanIdAsString?: string | null;
  ageCategoryIdAsString?: string | null;
  discountCode?: string | null;
  phoneNumber?: string | null;
  studentFullName?: string | null;
  parentFullName?: string | null;
  nationalCode?: string | null;
  genderAsString?: string | null;
  isFamiliarWithProgramming?: boolean | null;
}

export interface FusionSharedDtosInvoiceCreatePaymentLinkForExistingRequest {
  subscriptionPlanIdAsString?: string | null;
  discountPercent?: string | null;
  phoneNumber?: string | null;
  studentFullName?: string | null;
}

export interface FusionSharedDtosInvoiceCreatePaymentLinkRequest {
  subscriptionPlanIdAsString?: string | null;
  ageCategoryIdAsString?: string | null;
  discountPercent?: string | null;
  phoneNumber?: string | null;
  studentFullName?: string | null;
  parentFullName?: string | null;
  nationalCode?: string | null;
  genderAsString?: string | null;
  isFamiliarWithProgramming?: boolean | null;
}

export interface FusionSharedDtosInvoiceCreatePaymentLinkResponse {
  /** @format uuid */
  id?: string;
  url?: string | null;
  shoretnUrl?: string | null;
}

export interface FusionSharedDtosInvoiceGetPaymentLinkInfoResponse {
  subscriptionPlanTitle?: string | null;
  description?: string | null;
  subscriptionPlanId?: string | null;
  /** @format double */
  payableAmount?: number;
  /** @format double */
  subscriptionPlanAmount?: number;
  /** @format double */
  discountAmount?: number;
  /** @format double */
  taxAmount?: number;
}

export interface FusionSharedDtosInvoiceGetPaymentLinkResponse {
  parentFullName?: string | null;
  studentFullName?: string | null;
  phoneNumber?: string | null;
  ageCategoryTitle?: string | null;
  subscriptionPlanTitle?: string | null;
  description?: string | null;
  /** @format double */
  payableAmount?: number;
  /** @format double */
  subscriptionPlanAmount?: number;
  /** @format double */
  discountAmount?: number;
  /** @format double */
  taxAmount?: number;
  isPaid?: boolean;
}

export interface FusionSharedDtosInvoiceInvoiceInputDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  subscriberId?: string;
  /** @format uuid */
  billPayerId?: string;
  /** @format uuid */
  subscriptionPlanId?: string;
  /** @format date-time */
  date?: string;
  /** @format double */
  discount?: number;
  /** @format double */
  amount?: number;
}

export interface FusionSharedDtosInvoiceInvoiceOutputDto {
  subscriberFullName?: string | null;
  billPayerFullName?: string | null;
  billPayerUserName?: string | null;
  subscriptionPlanSupplyTitle?: string | null;
  subscriptionPlanSupplySubTitle?: string | null;
  subscriptionPlanCurrencySymbol?: string | null;
  /** @format double */
  subscriptionPlanPrice?: number;
  /** @format double */
  subscriptionPlanPayablePrice?: number;
  /** @format uuid */
  subscriberId?: string;
  /** @format date-time */
  date?: string;
  number?: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  discount?: number;
  /** @format double */
  taxAmount?: number;
  /** @format double */
  taxPercentAmount?: number;
  /** @format double */
  payableAmount?: number;
  gateways?: FusionSharedDtosSubscriptionGatewayDto[] | null;
}

export interface FusionSharedDtosInvoiceInvoicePaymentDto {
  urlRedirection?: string | null;
  /** @format uuid */
  pspLogId?: string | null;
}

export interface FusionSharedDtosInvoicePaymentLinkDto {
  /** @format uuid */
  id?: string;
  phoneNumber?: string | null;
  parentFullName?: string | null;
  studentFullName?: string | null;
  subscriptionPlanTitle?: string | null;
  ageCategoryTitle?: string | null;
  /** @format double */
  discountPercent?: number;
  url?: string | null;
  shoretnUrl?: string | null;
  gender?: FusionSharedEnumsGender;
  nationalCode?: string | null;
  isFamiliarWithProgramming?: boolean | null;
  isPaid?: boolean;
  /** @format date-time */
  createdOn?: string;
}

export interface FusionSharedDtosInvoiceSnappPayCancelRequest {
  /** @format uuid */
  id?: string;
}

export interface FusionSharedDtosInvoiceSnappPayCancelResponse {
  isOk?: boolean;
}

export interface FusionSharedDtosInvoiceSnappPayTransactionHistoryDto {
  transactionTitle?: string | null;
  /** @format date-time */
  date?: string;
  /** @format double */
  payable?: number;
  /** @format int64 */
  number?: number;
  paid?: boolean;
  subscriberName?: string | null;
  shortId?: string | null;
  /** @format uuid */
  pspLogId?: string;
  pspType?: FusionSharedEnumsPspType;
  /** @format uuid */
  id?: string;
  isCanceled?: boolean;
  transactionId?: string | null;
  paymentToken?: string | null;
  isSuccessful?: boolean;
}

export interface FusionSharedDtosInvoiceSnappPayTransactionHistoryRequestDto {
  shortTransactionId?: string | null;
}

export interface FusionSharedDtosInvoiceTransactionHistoryDto {
  transactionTitle?: string | null;
  /** @format date-time */
  date?: string;
  /** @format double */
  payable?: number;
  /** @format int64 */
  number?: number;
  paid?: boolean;
  subscriberName?: string | null;
  shortId?: string | null;
  /** @format uuid */
  pspLogId?: string;
  pspType?: FusionSharedEnumsPspType;
}

export interface FusionSharedDtosMeetingAddOrRescheduleMeetingInviteeInputDto {
  /** @format uuid */
  childUserId: string;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
}

export interface FusionSharedDtosMeetingAddOrRescheduleMeetingInviteeOutputDto {
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
  title?: string | null;
}

export interface FusionSharedDtosMeetingAgeCategoryOutputDto {
  /** @format uuid */
  id?: string;
  title?: string | null;
  agePeriod?: SystemTimeSpan;
}

export interface FusionSharedDtosMeetingMeetingInputDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  meetingOwnerId: string;
  /** @minLength 1 */
  meetingOwnerIdAsString: string;
  /** @format date-time */
  start?: string | null;
  /** @format date-time */
  end?: string | null;
  meetingStatus?: FusionSharedEnumsMeetingStatus;
  /** @minLength 1 */
  title: string;
  /**
   * @min 1
   * @max 999
   * @minLength 1
   */
  maxCapacity: string;
  /**
   * @min 2
   * @max 999
   * @minLength 1
   */
  minCapacity: string;
  /** @format uuid */
  fromAgeCategoryId: string;
  /** @minLength 1 */
  fromAgeCategoryIdAsString: string;
  /** @format uuid */
  toAgeCategoryId: string;
  /** @minLength 1 */
  toAgeCategoryIdAsString: string;
  gender: FusionSharedEnumsGender;
  /** @minLength 1 */
  genderAsString: string;
  /** @format date-time */
  date: string;
  /**
   * @minLength 1
   * @pattern ^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$
   */
  fromTime: string;
  /**
   * @minLength 1
   * @pattern ^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$
   */
  toTime: string;
  meetingType?: FusionSharedEnumsMeetingType;
}

export interface FusionSharedDtosMeetingMeetingOutputDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
  meetingStatus?: FusionSharedEnumsMeetingStatus;
  title?: string | null;
  /** @format int32 */
  minCapacity?: number;
  /** @format int32 */
  maxCapacity?: number;
  /** @format int32 */
  emptyCapacity?: number;
  /** @format uuid */
  fromAgeCategoryId?: string | null;
  fromAgeCategoryTitle?: string | null;
  /** @format uuid */
  toAgeCategoryId?: string | null;
  toAgeCategoryTitle?: string | null;
  /** @format uuid */
  meetingOwnerId?: string | null;
  meetingOwnerDisplayName?: string | null;
  gender?: FusionSharedEnumsGender;
  bbbId?: string | null;
  meetingType?: FusionSharedEnumsMeetingType;
}

export interface FusionSharedDtosMeetingMeetingTimeDto {
  /** @format uuid */
  studentId?: string;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
  meetingType?: FusionSharedEnumsMeetingType;
}

export interface FusionSharedDtosMeetingRescheduleMeetingInviteeInputDto {
  /** @format uuid */
  currentMeetingId?: string;
  /** @format uuid */
  studentId?: string;
  /** @format date-time */
  start?: string;
  /** @format date-time */
  end?: string;
  meetingInviteeStatus?: FusionSharedEnumsMeetingInviteeStatus;
}

export interface FusionSharedDtosMeetingRescheduleMeetingInviteeOutputDto {
  allowedToChange?: boolean;
  /** @format int32 */
  changedCount?: number;
}

export interface FusionSharedDtosMoodleClassAttendanceResponseDto {
  title?: string | null;
  /** @format date-time */
  createdOn?: string;
}

export interface FusionSharedDtosMoodleStudentCourseDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface FusionSharedDtosMoodleStudentLoginLogResponseDto {
  /** @format date-time */
  loginDate?: string;
  /** @format int32 */
  loginCount?: number;
}

export interface FusionSharedDtosMoodleStudentPerformanceResponseDto {
  assignmentName?: string | null;
  /** @format int32 */
  grade?: number;
  /** @format int32 */
  maxGrade?: number;
  scaleValues?: string | null;
  feedbackComment?: string | null;
}

export interface FusionSharedDtosMoodleStudentResponseDto {
  fullname?: string | null;
  planType?: FusionSharedEnumsPlanType;
  courses?: FusionSharedDtosMoodleStudentCourseDto[] | null;
  subscriptionPeriod?: FusionSharedDtosMoodleStudentSubscriptionPeriod;
}

export interface FusionSharedDtosMoodleStudentSubscriptionPeriod {
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface FusionSharedDtosMoodleStudentXpDto {
  /** @format int32 */
  courseId?: number;
  /** @format int32 */
  xp?: number | null;
  images?: FusionSharedDtosMoodleStudentXpImage[] | null;
}

export interface FusionSharedDtosMoodleStudentXpImage {
  path?: string | null;
  /** @format int32 */
  minTik?: number;
  /** @format int32 */
  maxTik?: number;
}

export interface FusionSharedDtosMoodleTutorContactInfoResponseDto {
  callType?: string | null;
  status?: string | null;
  /** @format date-time */
  createdOn?: string;
}

export interface FusionSharedDtosMoodleUpcomingEventDto {
  eventName?: string | null;
  courseName?: string | null;
  /** @format date-time */
  eventDateTime?: string;
}

export interface FusionSharedDtosNpsGetNpsFormByObjectIdResponse {
  /** @format uuid */
  npsId?: string;
  tutor?: FusionSharedDtosNpsGetNpsFormByObjectIdResponseTutorDto;
  course?: FusionSharedDtosNpsGetNpsFormByObjectIdResponseCourseDto;
  result?: FusionSharedDtosNpsGetNpsFormByObjectIdResponseResultDto;
  advantages?:
    | FusionSharedDtosNpsGetNpsFormByObjectIdResponseQuestionDto[]
    | null;
  disadvantages?:
    | FusionSharedDtosNpsGetNpsFormByObjectIdResponseQuestionDto[]
    | null;
}

export interface FusionSharedDtosNpsGetNpsFormByObjectIdResponseCourseDto {
  /** @format uuid */
  courseId?: string;
  name?: string | null;
  planType?: FusionSharedEnumsPlanType;
  enName?: string | null;
}

export interface FusionSharedDtosNpsGetNpsFormByObjectIdResponseQuestionDto {
  /** @format uuid */
  questionId?: string;
  title?: string | null;
}

export interface FusionSharedDtosNpsGetNpsFormByObjectIdResponseResultDto {
  /** @format float */
  rating?: number;
  description?: string | null;
  advantages?: string[] | null;
  disadvantages?: string[] | null;
}

export interface FusionSharedDtosNpsGetNpsFormByObjectIdResponseTutorDto {
  userName?: string | null;
  name?: string | null;
  family?: string | null;
}

export interface FusionSharedDtosNpsGetPendingNpsFormByUserResponse {
  items?: FusionSharedDtosNpsGetPendingNpsFormByUserResponseItemDto[] | null;
}

export interface FusionSharedDtosNpsGetPendingNpsFormByUserResponseItemDto {
  objectId?: string | null;
  isRequired?: boolean;
  hasNpsFormRecently?: boolean;
  /** @format uuid */
  studentId?: string;
}

export interface FusionSharedDtosPlacementCreateByBusinessUserRequest {
  /** @format uuid */
  userId?: string;
  placementType?: FusionSharedEnumsPlacementType;
  studentSubscriptionType?: FusionSharedEnumsPlacementRequestStudentSubscriptionType;
  /** @format uuid */
  selectedCourse?: string | null;
  removeFromOldCourses?: boolean | null;
}

export type FusionSharedDtosPlacementCreateByBusinessUserResponse = object;

export interface FusionSharedDtosPlacementGetAvailableCourseResponse {
  currentCourse?: FusionSharedDtosPlacementGetAvailableCourseResponseCourseDto;
  courses?:
    | FusionSharedDtosPlacementGetAvailableCourseResponseCourseDto[]
    | null;
}

export interface FusionSharedDtosPlacementGetAvailableCourseResponseCourseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  planType?: FusionSharedEnumsPlanType;
  enName?: string | null;
  topicName?: string | null;
  topicEnName?: string | null;
  /** @format int32 */
  educationalSort?: number;
  /** @format int32 */
  placementSort?: number | null;
  /** @format int32 */
  semester?: number;
}

export interface FusionSharedDtosPlacementGetHistoryListResponse {
  /** @format uuid */
  id?: string;
  type?: FusionSharedEnumsPlacementType;
  status?: FusionSharedEnumsPlacementStatus;
  /** @format date-time */
  expireAt?: string;
  /** @format date-time */
  createdOn?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  studentSubscriptionType?: FusionSharedEnumsPlacementRequestStudentSubscriptionType;
  creatorType?: FusionSharedEnumsPlacementRequestCreatorType;
  previousCourse?: FusionSharedDtosPlacementGetHistoryListResponseResultPreviousCourseDto;
  results?: FusionSharedDtosPlacementGetHistoryListResponseResultDto[] | null;
}

export interface FusionSharedDtosPlacementGetHistoryListResponseResultCourseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  planType?: FusionSharedEnumsPlanType;
}

export interface FusionSharedDtosPlacementGetHistoryListResponseResultDto {
  /** @format float */
  score?: number;
  /** @format date-time */
  completedAt?: string;
  status?: FusionSharedEnumsPlacementResultStatus;
  course?: FusionSharedDtosPlacementGetHistoryListResponseResultCourseDto;
}

export interface FusionSharedDtosPlacementGetHistoryListResponseResultPreviousCourseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface FusionSharedDtosPromotionBurnReferralInputDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  burnClaimNumber?: number;
}

export interface FusionSharedDtosPromotionPromotionCalcInputDto {
  /** @minLength 1 */
  code: string;
  /** @format uuid */
  invoiceId: string;
  pspType: FusionSharedEnumsPspType;
}

export interface FusionSharedDtosPromotionPromotionCalcOutputDto {
  /** @format double */
  percent?: number;
  /** @format double */
  discount?: number;
  /** @format double */
  payableAmount?: number;
  /** @format double */
  taxPercentAmount?: number;
  /** @format double */
  taxAmount?: number;
  gateways?: FusionSharedDtosSubscriptionGatewayDto[] | null;
}

export interface FusionSharedDtosPromotionPromotionInputDto {
  /** @format uuid */
  id?: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  code: string;
  /** @format date-time */
  validFrom: string;
  /** @format date-time */
  validTo: string;
  /** @minLength 1 */
  usableCount: string;
  /** @minLength 1 */
  maxInvoiceLimit: string;
  /** @minLength 1 */
  minInvoiceLimit: string;
  /**
   * @min 1
   * @max 100
   * @minLength 1
   */
  percent: string;
  /** @format uuid */
  userId?: string | null;
  /** @format uuid */
  modifierId?: string | null;
  isForInvite?: boolean;
  isForFirstSubscription?: boolean;
  snappPayUsageRestriction?: FusionSharedEnumsSnappPayUsageRestriction;
}

export interface FusionSharedDtosPromotionPromotionOutputDto {
  /** @format uuid */
  id?: string;
  code?: string | null;
  /** @format date-time */
  validFrom?: string;
  /** @format date-time */
  validTo?: string;
  /** @format int32 */
  usableCount?: number;
  /** @format int32 */
  usage?: number;
  /** @format double */
  minInvoiceLimit?: number;
  /** @format double */
  maxInvoiceLimit?: number;
  /** @format double */
  percent?: number;
  /** @format uuid */
  studentId?: string | null;
  userFullName?: string | null;
  isForInvite?: boolean;
  isForFirstSubscription?: boolean;
  snappPayUsageRestriction?: FusionSharedEnumsSnappPayUsageRestriction;
  /** @format uuid */
  referralId?: string;
  referral?: FusionSharedDtosPromotionReferralOutputDto;
}

export interface FusionSharedDtosPromotionReferralOutputDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  modifiedOn?: string;
  isArchived?: boolean;
  code?: string | null;
  /** @format int32 */
  claimNumber?: number;
  /** @format int32 */
  burnedClaimNumber?: number;
  user?: FusionSharedDtosUserUserOutputDto;
  /** @format uuid */
  userId?: string | null;
  userFullName?: string | null;
  /** @format int32 */
  usage?: number;
  /** @format int32 */
  usableCount?: number;
  /** @format int32 */
  abilityToBurn?: number;
  /** @format int32 */
  abilityToReferral?: number;
  claimableGift?: string | null;
  nextStep?: string | null;
  shareCodeText?: string | null;
  /** @format int32 */
  percentDiscount?: number;
}

export interface FusionSharedDtosPromotionReferrerOutputDto {
  /** @format uuid */
  id?: string;
  userFullName?: string | null;
}

export interface FusionSharedDtosPromotionUserInputDto {
  /** @format uuid */
  id?: string;
  canSeeEconomy?: boolean | null;
  canSeeTrial?: boolean | null;
  canAddStudent?: boolean | null;
}

export interface FusionSharedDtosPspPspErrorDto {
  message?: string | null;
}

export interface FusionSharedDtosPspPspResultOutputDto {
  pspLog?: FusionSharedDtosPspPspSadadLogOutputDto;
  invoice?: FusionSharedDtosInvoiceInvoiceOutputDto;
}

export interface FusionSharedDtosPspPspSadadLogOutputDto {
  /** @format int64 */
  number?: number;
  /** @format double */
  amount?: number;
  /** @format date-time */
  verifiedOn?: string;
  /** @format uuid */
  invoiceId?: string | null;
  paymentSuccessful?: boolean;
  pspType?: FusionSharedEnumsPspType;
  shortId?: string | null;
}

export interface FusionSharedDtosPspSuccessPspSadadLogOutputDto {
  /** @format int64 */
  number?: number;
  /** @format double */
  amount?: number;
  /** @format date-time */
  verifiedOn?: string;
  /** @format uuid */
  invoiceId?: string | null;
  paymentSuccessful?: boolean;
  pspType?: FusionSharedEnumsPspType;
  shortId?: string | null;
  signIn?: FusionSharedDtosAccountSignInResponseDto;
}

export interface FusionSharedDtosShortenUrlCreateShortenUrlRequest {
  name?: string | null;
  url?: string | null;
  token?: string | null;
  isActive?: boolean;
}

export type FusionSharedDtosShortenUrlCreateShortenUrlResponse = object;

export interface FusionSharedDtosShortenUrlListShortenUrlResponse {
  /** @format uuid */
  id?: string;
  name?: string | null;
  url?: string | null;
  token?: string | null;
  isActive?: boolean;
  /** @format int32 */
  totalClickedCount?: number;
  /** @format date-time */
  lastClickedAt?: string | null;
  /** @format date-time */
  createdOn?: string;
  creator?: FusionSharedDtosShortenUrlListShortenUrlResponseCreatorDto;
}

export interface FusionSharedDtosShortenUrlListShortenUrlResponseCreatorDto {
  /** @format uuid */
  id?: string;
  fullName?: string | null;
}

export interface FusionSharedDtosShortenUrlTokenShortenUrlResponse {
  token?: string | null;
}

export interface FusionSharedDtosShortenUrlUpdateShortenUrlRequest {
  /** @format uuid */
  id?: string;
  name?: string | null;
  url?: string | null;
  isActive?: boolean;
}

export type FusionSharedDtosShortenUrlUpdateShortenUrlResponse = object;

export interface FusionSharedDtosSubscriptionCheapestPlanRequestDto {
  /** @format uuid */
  userId?: string;
  planTypes?: FusionSharedEnumsPlanType[] | null;
}

export interface FusionSharedDtosSubscriptionCurrencyDto {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  code: string;
}

export interface FusionSharedDtosSubscriptionFilterSubscriptionForBookingDto {
  nationalCode?: string | null;
  gender?: FusionSharedEnumsGender;
  name?: string | null;
  phone?: string | null;
  planType?: FusionSharedEnumsPlanType;
  courseIds?: string[] | null;
  ageCategoryIds?: string[] | null;
  /** @format date-time */
  subscriptionDateFrom?: string | null;
  /** @format date-time */
  subscriptionDateTo?: string | null;
}

export interface FusionSharedDtosSubscriptionFilterSubscriptionForBookingResultCourseDto {
  /** @format uuid */
  id?: string | null;
  name?: string | null;
}

export interface FusionSharedDtosSubscriptionFilterSubscriptionForBookingResultDto {
  /** @format uuid */
  userId?: string;
  gender?: FusionSharedEnumsGender;
  name?: string | null;
  phone?: string | null;
  nationalCode?: string | null;
  planType?: string | null;
  saleType?: string | null;
  userCurrentCourse?: FusionSharedDtosSubscriptionFilterSubscriptionForBookingResultCourseDto;
  initialAgeCategoryTitle?: string | null;
  /** @format uuid */
  userSubscriptionId?: string;
  /** @format date-time */
  expireAt?: string;
  /** @format date-time */
  paidOn?: string | null;
  subscriptionPlanSupplyTitle?: string | null;
  hasTimeSlot?: boolean;
  timeSlot?: FusionSharedDtosSubscriptionFilterSubscriptionForBookingResultTimeSlotDto;
  /** @format date-time */
  createdOn?: string | null;
}

export interface FusionSharedDtosSubscriptionFilterSubscriptionForBookingResultTimeSlotDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  actualStartedAt?: string | null;
  /** @format date-time */
  endedAt?: string | null;
  /** @format date-time */
  actualEndedAt?: string | null;
  state?: FusionSharedEnumsTimeSlotState;
}

export interface FusionSharedDtosSubscriptionGatewayDto {
  id?: string | null;
  type?: FusionSharedEnumsPspType;
  imageUrl?: string | null;
  name?: string | null;
  description?: string | null;
  log?: string | null;
}

export interface FusionSharedDtosSubscriptionSubscriptionPlanDto {
  /** @format uuid */
  id?: string;
  supportContactRequired?: boolean;
  supportUrl?: string | null;
  /** @format uuid */
  subscriberId?: string;
  supply?: FusionSharedDtosSubscriptionSupplyDto;
  currency?: FusionSharedDtosSubscriptionCurrencyDto;
  /** @format double */
  price?: number;
  /** @format double */
  payablePrice?: number;
  /** @format double */
  totalPayablePrice?: number;
  /** @format double */
  taxPercent?: number;
  /** @format int32 */
  totalMeetingCount?: number;
  supplyPeriod?: SystemTimeSpan;
  /** @format double */
  pricePerMonth?: number;
  /** @format double */
  pricePerDay?: number;
  /** @format int32 */
  planType?: number;
  gateways?: FusionSharedDtosSubscriptionGatewayDto[] | null;
}

export interface FusionSharedDtosSubscriptionSubscriptionPlanInfoDto {
  title?: string | null;
  /** @format double */
  amount?: number;
  /** @format uuid */
  id?: string;
}

export interface FusionSharedDtosSubscriptionSubscriptionPlanUpdateDto {
  /** @format uuid */
  id?: string;
  amount?: string | null;
  title?: string | null;
}

export interface FusionSharedDtosSubscriptionSupplyDto {
  /** @minLength 1 */
  title: string;
  subTitle?: string | null;
  isMainSupply?: boolean;
  /** @format int32 */
  totalMeetingCount?: number;
  supplyItems?: FusionSharedDtosSubscriptionSupplyItemDto[] | null;
  description?: string | null;
}

export interface FusionSharedDtosSubscriptionSupplyItemDto {
  /** @minLength 1 */
  title: string;
  /** @format date-time */
  createdOn?: string;
}

export interface FusionSharedDtosSubscriptionUserSubscriptionHistoryDto {
  subscriberDisplayName?: string | null;
  subscriptionPlanSupplyTitle?: string | null;
  /** @format date-time */
  expireAt?: string;
  /** @format date-time */
  paidOn?: string | null;
  /** @format double */
  payable?: number;
  capabilityStatus?: FusionSharedEnumsUserCapabilityStatus;
  /** @format uuid */
  userId?: string;
  planType?: string | null;
  /** @format uuid */
  id?: string;
}

export interface FusionSharedDtosUserAdjustUserInformation {
  /** @format uuid */
  studentId?: string;
  gender?: FusionSharedEnumsGender;
  /** @format uuid */
  ageCategoryId?: string;
}

export interface FusionSharedDtosUserAdminListResponseDto {
  items?: FusionSharedDtosUserAdminListResponseItemsDto[] | null;
  /** @format int64 */
  count?: number;
}

export interface FusionSharedDtosUserAdminListResponseItemsDto {
  /** @format uuid */
  id?: string;
  fullName?: string | null;
  phoneNumber?: string | null;
  userName?: string | null;
  /** @format date-time */
  lockoutEnd?: string | null;
  isLock?: boolean;
  roles?: string[] | null;
  roleString?: string | null;
}

export interface FusionSharedDtosUserAllowChangePlanRequest {
  /** @format uuid */
  studentId?: string;
}

export type FusionSharedDtosUserAllowChangePlanResponse = object;

export interface FusionSharedDtosUserBusinessUserCreateDto {
  fullName?: string | null;
  phoneNumber?: string | null;
  password?: string | null;
}

export interface FusionSharedDtosUserBusinessUserUpdateDto {
  /** @format uuid */
  id?: string;
  isActive?: boolean;
  fullName?: string | null;
  phoneNumber?: string | null;
  password?: string | null;
}

export interface FusionSharedDtosUserParentDeleteDto {
  /** @format uuid */
  id?: string;
}

export interface FusionSharedDtosUserRemoveUserSubscriptionRequest {
  /** @format uuid */
  studentId?: string;
}

export type FusionSharedDtosUserRemoveUserSubscriptionResponse = object;

export interface FusionSharedDtosUserSetSelectedUserTypeDto {
  userType?: FusionSharedEnumsUserType;
}

export interface FusionSharedDtosUserStudentProfileResponseAgeCategoryDto {
  /** @format uuid */
  id?: string;
  title?: string | null;
  code?: string | null;
}

export interface FusionSharedDtosUserStudentProfileResponseCourseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface FusionSharedDtosUserStudentProfileResponseDto {
  /** @format uuid */
  id?: string;
  fullName?: string | null;
  /** @format uuid */
  parentId?: string;
  parentFullName?: string | null;
  allowChangePlan?: boolean;
  parentPhoneNumber?: string | null;
  countryCode?: string | null;
  rolesInMoodle?: string[] | null;
  planType?: FusionSharedEnumsPlanType;
  gender?: FusionSharedEnumsGender;
  capabilityStatus?: FusionSharedEnumsUserCapabilityStatus;
  subscriptionType?: FusionSharedEnumsSubscriptionType;
  /** @format uuid */
  userCurrentSubscriptionId?: string | null;
  /** @format date-time */
  createdOn?: string;
  ageCategory?: FusionSharedDtosUserStudentProfileResponseAgeCategoryDto;
  timeSlot?: FusionSharedDtosUserStudentProfileResponseTimeSlotDto;
  currentCourse?: FusionSharedDtosUserStudentProfileResponseCourseDto;
  courseBasedOnAge?: FusionSharedDtosUserStudentProfileResponseCourseDto;
  canSeeEconomy?: boolean;
  canSeeTrial?: boolean;
  canAddStudent?: boolean;
  saleType?: FusionSharedEnumsSaleType;
  /** @format date-time */
  birthDate?: string | null;
}

export interface FusionSharedDtosUserStudentProfileResponseTimeSlotDto {
  /** @format uuid */
  id?: string;
  businessDay?: FusionSharedEnumsBusinessDay;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  endedAt?: string | null;
  /** @format date-time */
  timeInWeekStartedAt?: string;
  state?: FusionSharedEnumsTimeSlotState;
  /** @format date-time */
  timeInWeekEndedAt?: string;
  tutor?: FusionSharedDtosUserStudentProfileResponseTimeSlotTutorDto;
}

export interface FusionSharedDtosUserStudentProfileResponseTimeSlotTutorDto {
  /** @format uuid */
  id?: string;
  username?: string | null;
  name?: string | null;
  family?: string | null;
}

export interface FusionSharedDtosUserStudentsDeleteDto {
  /** @format uuid */
  id?: string;
}

export interface FusionSharedDtosUserStudentsListRequestDto {
  placementStatus?: FusionSharedEnumsPlacementStatus[] | null;
  withoutActivePlacementRequest?: boolean | null;
  hasAllocation?: boolean | null;
  planType?: FusionSharedEnumsPlanType;
  currentCourses?: string[] | null;
  search?: string | null;
  gender?: FusionSharedEnumsGender;
  userCapabilityStatus?: FusionSharedEnumsUserCapabilityStatus[] | null;
  userSubscriptionType?: FusionSharedEnumsSubscriptionType[] | null;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  pageNumber?: number;
}

export interface FusionSharedDtosUserStudentsListResponseDto {
  items?: FusionSharedDtosUserStudentsListResponseItemsDto[] | null;
  /** @format int64 */
  count?: number;
}

export interface FusionSharedDtosUserStudentsListResponseItemCurrentCourseDto {
  /** @format uuid */
  id?: string | null;
  name?: string | null;
}

export interface FusionSharedDtosUserStudentsListResponseItemTimeSlotDto {
  /** @format uuid */
  id?: string | null;
  businessDay?: FusionSharedEnumsBusinessDay;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  endedAt?: string | null;
  /** @format date-time */
  timeInWeekStartedAt?: string | null;
  /** @format date-time */
  timeInWeekEndedAt?: string | null;
  tutor?: FusionSharedDtosUserStudentsListResponseItemTimeSlotTutorDto;
  state?: FusionSharedEnumsTimeSlotState;
}

export interface FusionSharedDtosUserStudentsListResponseItemTimeSlotTutorDto {
  /** @format uuid */
  id?: string | null;
  username?: string | null;
  name?: string | null;
  family?: string | null;
}

export interface FusionSharedDtosUserStudentsListResponseItemsDto {
  /** @format uuid */
  id?: string;
  fullName?: string | null;
  /** @format uuid */
  parentId?: string;
  parentFullName?: string | null;
  parentPhoneNumber?: string | null;
  planType?: FusionSharedEnumsPlanType;
  /** @format uuid */
  subscriptionId?: string | null;
  gender?: FusionSharedEnumsGender;
  subscriptionType?: FusionSharedEnumsSubscriptionType;
  capabilityStatus?: FusionSharedEnumsUserCapabilityStatus;
  lastPlacementStatus?: FusionSharedEnumsPlacementStatus;
  timeSlot?: FusionSharedDtosUserStudentsListResponseItemTimeSlotDto;
  currentCourse?: FusionSharedDtosUserStudentsListResponseItemCurrentCourseDto;
}

export interface FusionSharedDtosUserSyncUserCurrentCoursesWithMoodleRequestDto {
  ifHasNoCourse?: boolean;
  byMoodle?: boolean;
  /** @format int32 */
  chunkCount?: number | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  subscriptionTypes?: FusionSharedEnumsSubscriptionType[] | null;
  /** @format uuid */
  userId?: string | null;
}

export interface FusionSharedDtosUserSyncUserCurrentCoursesWithMoodleResponseDto {
  /** @format int32 */
  total?: number;
  /** @format int32 */
  totalSynced?: number;
}

export interface FusionSharedDtosUserUpdateUserInformationByBusinessUserRequest {
  /** @format uuid */
  userId?: string;
  /** @format uuid */
  course?: string | null;
  gender?: FusionSharedEnumsGender;
  /** @format uuid */
  initialAgeCategoryId?: string | null;
  fullName?: string | null;
  phoneNumber?: string | null;
}

export type FusionSharedDtosUserUpdateUserInformationByBusinessUserResponse =
  object;

export interface FusionSharedDtosUserUpdateUserMoodleStatusToSuspendedRequest {
  /** @format uuid */
  studentId?: string;
}

export type FusionSharedDtosUserUpdateUserMoodleStatusToSuspendedResponse =
  object;

export interface FusionSharedDtosUserUpdateUserMoodleStatusToSuspendingRequest {
  /** @format uuid */
  studentId?: string;
}

export type FusionSharedDtosUserUpdateUserMoodleStatusToSuspendingResponse =
  object;

export interface FusionSharedDtosUserUserMainRolesDto {
  userTypes?: FusionSharedEnumsUserType[] | null;
}

export interface FusionSharedDtosUserUserOutputDto {
  /** @format uuid */
  id?: string;
  userName?: string | null;
  fullName?: string | null;
  gender?: FusionSharedEnumsGender;
  initialAgeCategoryTitle?: string | null;
  phoneNumber?: string | null;
  /** @format date-time */
  expirationDateTime?: string;
  userPlanType?: FusionSharedEnumsPlanType;
  canSeeEconomy?: boolean;
  canSeeTrial?: boolean;
  canAddStudent?: boolean;
  warningMessage?: string | null;
  hasSubscription?: FusionSharedEnumsSubscriptionStatus;
  /** @format int32 */
  usage?: number;
}

export type FusionSharedDtosZeblineZeblineAttributesResponseDto = object;

export interface SystemTimeSpan {
  /** @format int64 */
  ticks?: number;
  /** @format int32 */
  days?: number;
  /** @format int32 */
  hours?: number;
  /** @format int32 */
  milliseconds?: number;
  /** @format int32 */
  microseconds?: number;
  /** @format int32 */
  nanoseconds?: number;
  /** @format int32 */
  minutes?: number;
  /** @format int32 */
  seconds?: number;
  /** @format double */
  totalDays?: number;
  /** @format double */
  totalHours?: number;
  /** @format double */
  totalMilliseconds?: number;
  /** @format double */
  totalMicroseconds?: number;
  /** @format double */
  totalNanoseconds?: number;
  /** @format double */
  totalMinutes?: number;
  /** @format double */
  totalSeconds?: number;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Fusion.Server
 * @version 1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Attachment
     * @name AttachmentUploadProfileImageCreate
     * @request POST:/api/Attachment/UploadProfileImage
     * @secure
     */
    attachmentUploadProfileImageCreate: (
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Attachment/UploadProfileImage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attachment
     * @name AttachmentRemoveProfileImageDelete
     * @request DELETE:/api/Attachment/RemoveProfileImage
     * @secure
     */
    attachmentRemoveProfileImageDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Attachment/RemoveProfileImage`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attachment
     * @name AttachmentGetProfileImageList
     * @request GET:/api/Attachment/GetProfileImage
     * @secure
     */
    attachmentGetProfileImageList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Attachment/GetProfileImage`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSignUpByEmailCreate
     * @request POST:/api/Auth/SignUpByEmail
     * @secure
     */
    authSignUpByEmailCreate: (
      data: FusionSharedDtosAccountSignUpRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/SignUpByEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAddPasswordCreate
     * @request POST:/api/Auth/AddPassword
     * @secure
     */
    authAddPasswordCreate: (
      data: FusionSharedDtosAccountAddPasswordRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/AddPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSignUpByPhoneNumberCreate
     * @request POST:/api/Auth/SignUpByPhoneNumber
     * @secure
     */
    authSignUpByPhoneNumberCreate: (
      data: FusionSharedDtosAccountSignUpRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/SignUpByPhoneNumber`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSendConfirmationEmailCreate
     * @request POST:/api/Auth/SendConfirmationEmail
     * @secure
     */
    authSendConfirmationEmailCreate: (
      data: FusionSharedDtosAccountSendConfirmationEmailRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/SendConfirmationEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSendResetPasswordEmailCreate
     * @request POST:/api/Auth/SendResetPasswordEmail
     * @secure
     */
    authSendResetPasswordEmailCreate: (
      data: FusionSharedDtosAccountSendResetPasswordEmailRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/SendResetPasswordEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthConfirmEmailCreate
     * @request POST:/api/Auth/ConfirmEmail
     * @secure
     */
    authConfirmEmailCreate: (
      data: FusionSharedDtosAccountConfirmEmailRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/ConfirmEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthConfirmPhoneNumberCreate
     * @request POST:/api/Auth/ConfirmPhoneNumber
     * @secure
     */
    authConfirmPhoneNumberCreate: (
      data: FusionSharedDtosAccountOtpTokenRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountSignInResponseDto, any>({
        path: `/api/Auth/ConfirmPhoneNumber`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAdminResetPasswordCreate
     * @request POST:/api/Auth/AdminResetPassword
     * @secure
     */
    authAdminResetPasswordCreate: (
      data: FusionSharedDtosAccountAdminResetPasswordRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/AdminResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthResetPasswordCreate
     * @request POST:/api/Auth/ResetPassword
     * @secure
     */
    authResetPasswordCreate: (
      data: FusionSharedDtosAccountResetPasswordRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/ResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthChangePasswordCreate
     * @request POST:/api/Auth/ChangePassword
     * @secure
     */
    authChangePasswordCreate: (
      data: FusionSharedDtosAccountChangePasswordRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/ChangePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSignInCreate
     * @request POST:/api/Auth/SignIn
     * @secure
     */
    authSignInCreate: (
      data: FusionSharedDtosAccountSignInRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountSignInResponseDto, any>({
        path: `/api/Auth/SignIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthUnlockUserCreate
     * @request POST:/api/Auth/UnlockUser
     * @secure
     */
    authUnlockUserCreate: (data: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Auth/UnlockUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRefreshTokenCreate
     * @request POST:/api/Auth/RefreshToken
     * @secure
     */
    authRefreshTokenCreate: (
      data: FusionSharedDtosAccountRefreshTokenRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountRefreshTokenResopnseDto, any>({
        path: `/api/Auth/RefreshToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSendOtpTokenCreate
     * @request POST:/api/Auth/SendOtpToken
     * @secure
     */
    authSendOtpTokenCreate: (
      data: FusionSharedDtosAccountSendOtpTokenRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/SendOtpToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSendOtpTokenViaVoiceCallCreate
     * @request POST:/api/Auth/SendOtpTokenViaVoiceCall
     * @secure
     */
    authSendOtpTokenViaVoiceCallCreate: (
      data: FusionSharedDtosAccountSendOtpTokenRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/SendOtpTokenViaVoiceCall`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRegisterStudentCreate
     * @request POST:/api/Auth/RegisterStudent
     * @secure
     */
    authRegisterStudentCreate: (
      data: FusionSharedDtosAccountEditUserDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserUserOutputDto, any>({
        path: `/api/Auth/RegisterStudent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSignInUsingOtpCreate
     * @request POST:/api/Auth/SignInUsingOtp
     * @secure
     */
    authSignInUsingOtpCreate: (
      data: FusionSharedDtosAccountOtpTokenRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountSignInResponseDto, any>({
        path: `/api/Auth/SignInUsingOtp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthCampaignSignUpByPhoneNumberCreate
     * @request POST:/api/Auth/CampaignSignUpByPhoneNumber
     * @secure
     */
    authCampaignSignUpByPhoneNumberCreate: (
      data: FusionSharedDtosAccountCampaignSignUpInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountCampaignSignUpOutputDto, any>({
        path: `/api/Auth/CampaignSignUpByPhoneNumber`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthCampaignQuickSignUpByPhoneNumberCreate
     * @request POST:/api/Auth/CampaignQuickSignUpByPhoneNumber
     * @secure
     */
    authCampaignQuickSignUpByPhoneNumberCreate: (
      data: FusionSharedDtosAccountCampaignSignUpInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountCampaignSignUpOutputDto, any>({
        path: `/api/Auth/CampaignQuickSignUpByPhoneNumber`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGeneratePasswordForUserListCreate
     * @request POST:/api/Auth/GeneratePasswordForUserList
     * @secure
     */
    authGeneratePasswordForUserListCreate: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Auth/GeneratePasswordForUserList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLandingSignUpCreate
     * @request POST:/api/Auth/LandingSignUp
     * @secure
     */
    authLandingSignUpCreate: (
      data: FusionSharedDtosAccountCampaignSignUpInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserUserOutputDto, any>({
        path: `/api/Auth/LandingSignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGetUserCurrentRoleCreate
     * @request POST:/api/Auth/GetUserCurrentRole
     * @secure
     */
    authGetUserCurrentRoleCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Auth/GetUserCurrentRole`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BigBlueButton
     * @name BigBlueButtonUserLeftCallbackCreate
     * @request POST:/api/BigBlueButton/UserLeftCallback
     * @secure
     */
    bigBlueButtonUserLeftCallbackCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/BigBlueButton/UserLeftCallback`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BigBlueButton
     * @name BigBlueButtonMeetingEndCallbackCreate
     * @request POST:/api/BigBlueButton/MeetingEndCallback
     * @secure
     */
    bigBlueButtonMeetingEndCallbackCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/BigBlueButton/MeetingEndCallback`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingAcceptCreate
     * @request POST:/api/Booking/Accept
     * @secure
     */
    bookingAcceptCreate: (
      data: BookingManagementHandlersAcceptBookingCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Booking/Accept`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingRejectCreate
     * @request POST:/api/Booking/Reject
     * @secure
     */
    bookingRejectCreate: (
      data: BookingManagementHandlersRejectBookingCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Booking/Reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingCreateByTutorCreate
     * @request POST:/api/Booking/CreateByTutor
     * @secure
     */
    bookingCreateByTutorCreate: (
      data: BookingManagementHandlersCreateNewBookingByTutorCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Booking/CreateByTutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingAvailableDateTimesToCreateTimeSlotDetail
     * @request GET:/api/Booking/AvailableDateTimesToCreateTimeSlot/{tutorId}
     * @secure
     */
    bookingAvailableDateTimesToCreateTimeSlotDetail: (
      tutorId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Booking/AvailableDateTimesToCreateTimeSlot/${tutorId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Course
     * @name CourseList
     * @request GET:/api/Course
     * @secure
     */
    courseList: (
      query?: {
        query?: BookingManagementHandlersGetCoursesQuery;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Course`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Course
     * @name CourseRemoveDuplicatedMoodleIdList
     * @request GET:/api/Course/remove-duplicated-moodleId
     * @secure
     */
    courseRemoveDuplicatedMoodleIdList: (
      query?: {
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Course/remove-duplicated-moodleId`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DebugMode
     * @name DebugModeTestCreate
     * @request POST:/api/DebugMode/test
     * @secure
     */
    debugModeTestCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/DebugMode/test`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitBanksList
     * @request GET:/api/DirectDebit/Banks
     * @secure
     */
    directDebitBanksList: (
      query?: {
        request?: FusionSharedDtosDirectDebitDirectDebitGetBankRequestDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitGetBankResponseDto,
        any
      >({
        path: `/api/DirectDebit/Banks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitParentInformationList
     * @request GET:/api/DirectDebit/ParentInformation
     * @secure
     */
    directDebitParentInformationList: (
      query?: {
        request?: FusionSharedDtosDirectDebitDirectDebitGetParentInformationRequestDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitGetParentInformationResponseDto,
        any
      >({
        path: `/api/DirectDebit/ParentInformation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitParentCurrentAuthorizationList
     * @request GET:/api/DirectDebit/ParentCurrentAuthorization
     * @secure
     */
    directDebitParentCurrentAuthorizationList: (
      query?: {
        request?: FusionSharedDtosDirectDebitDirectDebitGetParentCurrentAuthorizationRequestDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitGetParentCurrentAuthorizationResponseDto,
        any
      >({
        path: `/api/DirectDebit/ParentCurrentAuthorization`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitNewAuthorizeCreate
     * @request POST:/api/DirectDebit/NewAuthorize
     * @secure
     */
    directDebitNewAuthorizeCreate: (
      data: FusionSharedDtosDirectDebitDirectDebitPostNewAuthorizeRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitPostNewAuthorizeResponseDto,
        any
      >({
        path: `/api/DirectDebit/NewAuthorize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitVerifyAuthorizeList
     * @request GET:/api/DirectDebit/VerifyAuthorize
     * @secure
     */
    directDebitVerifyAuthorizeList: (
      query?: {
        AuthorizationId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/DirectDebit/VerifyAuthorize`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitRevokeAuthorizeCreate
     * @request POST:/api/DirectDebit/RevokeAuthorize
     * @secure
     */
    directDebitRevokeAuthorizeCreate: (
      data: FusionSharedDtosDirectDebitDirectDebitPostRevokeAuthorizeRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitPostRevokeAuthorizeResponseDto,
        any
      >({
        path: `/api/DirectDebit/RevokeAuthorize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitAuthorizeListForParentCreate
     * @request POST:/api/DirectDebit/AuthorizeListForParent
     * @secure
     */
    directDebitAuthorizeListForParentCreate: (
      data: FusionSharedDtosDirectDebitDirectDebitGetAuthorizeListRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitGetAuthorizeListResponseDto,
        any
      >({
        path: `/api/DirectDebit/AuthorizeListForParent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitAuthorizeListForBusinessUserCreate
     * @request POST:/api/DirectDebit/AuthorizeListForBusinessUser
     * @secure
     */
    directDebitAuthorizeListForBusinessUserCreate: (
      data: FusionSharedDtosDirectDebitDirectDebitGetAuthorizeListRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitGetAuthorizeListResponseDto,
        any
      >({
        path: `/api/DirectDebit/AuthorizeListForBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectDebit
     * @name DirectDebitWithdrawalListCreate
     * @request POST:/api/DirectDebit/WithdrawalList
     * @secure
     */
    directDebitWithdrawalListCreate: (
      data: FusionSharedDtosDirectDebitDirectDebitGetWithdrawalListRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectDebitDirectDebitGetWithdrawalListResponseDto,
        any
      >({
        path: `/api/DirectDebit/WithdrawalList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserSignupCreate
     * @request POST:/api/DirectUser/Signup
     * @secure
     */
    directUserSignupCreate: (
      data: FusionSharedDtosDirectUserDirectUserSignupRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosDirectUserDirectSignupResponseDto, any>({
        path: `/api/DirectUser/Signup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserProfileList
     * @request GET:/api/DirectUser/Profile
     * @secure
     */
    directUserProfileList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosDirectUserDirectUserProfileResponseDto, any>(
        {
          path: `/api/DirectUser/Profile`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserUpComingMeetingsList
     * @request GET:/api/DirectUser/UpComingMeetings
     * @secure
     */
    directUserUpComingMeetingsList: (
      query?: {
        /** @format uuid */
        studentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto[], any>({
        path: `/api/DirectUser/UpComingMeetings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserCompleteRegistrationUpdate
     * @request PUT:/api/DirectUser/CompleteRegistration
     * @secure
     */
    directUserCompleteRegistrationUpdate: (
      data: FusionSharedDtosAccountEditUserDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosDirectUserDirectUserProfileResponseDto, any>(
        {
          path: `/api/DirectUser/CompleteRegistration`,
          method: "PUT",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserUpdateLastStepUpdate
     * @request PUT:/api/DirectUser/UpdateLastStep
     * @secure
     */
    directUserUpdateLastStepUpdate: (
      data: FusionSharedDtosDirectUserDirectUserUpdateLastStepRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosDirectUserDirectUserProfileResponseDto, any>(
        {
          path: `/api/DirectUser/UpdateLastStep`,
          method: "PUT",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserUndoStudentBulkInsertUpdate
     * @request PUT:/api/DirectUser/UndoStudentBulkInsert
     * @secure
     */
    directUserUndoStudentBulkInsertUpdate: (
      data: FusionSharedDtosDirectUserStudentBulkInsertRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosDirectUserUndoStudentBulkInsertResponseDto,
        any
      >({
        path: `/api/DirectUser/UndoStudentBulkInsert`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserStudentBulkInsertByFileCreate
     * @request POST:/api/DirectUser/StudentBulkInsertByFile
     * @secure
     */
    directUserStudentBulkInsertByFileCreate: (
      data: {
        /** @format binary */
        File?: File;
      },
      query?: {
        AllowIfExists?: boolean;
        AllowIfHasSubscription?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosDirectUserStudentBulkInsertResponseDto, any>(
        {
          path: `/api/DirectUser/StudentBulkInsertByFile`,
          method: "POST",
          query: query,
          body: data,
          secure: true,
          type: ContentType.FormData,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags DirectUser
     * @name DirectUserStudentBulkInsertCreate
     * @request POST:/api/DirectUser/StudentBulkInsert
     * @secure
     */
    directUserStudentBulkInsertCreate: (
      data: FusionSharedDtosDirectUserStudentBulkInsertRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosDirectUserStudentBulkInsertResponseDto, any>(
        {
          path: `/api/DirectUser/StudentBulkInsert`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Finance
     * @name FinancePortalList
     * @request GET:/api/Finance/portal
     * @secure
     */
    financePortalList: (
      query?: {
        /** @format date-time */
        startAt?: string;
        /** @format date-time */
        endAt?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/portal`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinancePortalExportList
     * @request GET:/api/Finance/portal-export
     * @secure
     */
    financePortalExportList: (
      query?: {
        /** @format date-time */
        startAt?: string;
        /** @format date-time */
        endAt?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/portal-export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceAccountingExportList
     * @request GET:/api/Finance/accounting-export
     * @secure
     */
    financeAccountingExportList: (
      query?: {
        /** @format date-time */
        startAt?: string;
        /** @format date-time */
        endAt?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/accounting-export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceAccountingList
     * @request GET:/api/Finance/accounting
     * @secure
     */
    financeAccountingList: (
      query?: {
        /** @format date-time */
        startAt?: string;
        /** @format date-time */
        endAt?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/accounting`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceRimaExportList
     * @request GET:/api/Finance/rima-export
     * @secure
     */
    financeRimaExportList: (
      query?: {
        /** @format date-time */
        startAt?: string;
        /** @format date-time */
        endAt?: string;
        token?: string;
        uploadReady?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/rima-export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceRimaList
     * @request GET:/api/Finance/rima
     * @secure
     */
    financeRimaList: (
      query?: {
        /** @format date-time */
        startAt?: string;
        /** @format date-time */
        endAt?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/rima`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceLogInitiatorCreate
     * @request POST:/api/Finance/log-initiator
     * @secure
     */
    financeLogInitiatorCreate: (
      data: {
        /** @format binary */
        SadadPsp?: File;
        /** @format binary */
        Vandar?: File;
        /** @format binary */
        SnappPay?: File;
        /** @format binary */
        Baam?: File;
      },
      query?: {
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/log-initiator`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceMapperCreate
     * @request POST:/api/Finance/mapper
     * @secure
     */
    financeMapperCreate: (
      query?: {
        Token?: string;
        /** @format date-time */
        StartAt?: string;
        /** @format date-time */
        EndAt?: string;
        BasedOn?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/mapper`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceUnmappedCreate
     * @request POST:/api/Finance/unmapped
     * @secure
     */
    financeUnmappedCreate: (
      query?: {
        Token?: string;
        /** @format date-time */
        StartAt?: string;
        /** @format date-time */
        EndAt?: string;
        BasedOn?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/unmapped`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finance
     * @name FinanceInvoiceCalculationList
     * @request GET:/api/Finance/invoice-calculation
     * @secure
     */
    financeInvoiceCalculationList: (
      query?: {
        token?: string;
        /** @format int32 */
        startNumber?: number;
        /** @format int32 */
        endNumber?: number;
        /** @default false */
        forceUpdate?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Finance/invoice-calculation`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryList
     * @request GET:/api/Gallery
     * @secure
     */
    galleryList: (params: RequestParams = {}) =>
      this.request<FusionApiModelsUIGallery[], any>({
        path: `/api/Gallery`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryCreate
     * @request POST:/api/Gallery
     * @secure
     */
    galleryCreate: (
      data: FusionApiModelsUIGallery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Gallery`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryDetail
     * @request GET:/api/Gallery/{id}
     * @secure
     */
    galleryDetail: (id: string, params: RequestParams = {}) =>
      this.request<FusionApiModelsUIGallery, any>({
        path: `/api/Gallery/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryUpdate
     * @request PUT:/api/Gallery/{id}
     * @secure
     */
    galleryUpdate: (
      id: string,
      data: FusionApiModelsUIGallery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Gallery/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryDelete
     * @request DELETE:/api/Gallery/{id}
     * @secure
     */
    galleryDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Gallery/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryGetDashboardBannersList
     * @request GET:/api/Gallery/GetDashboardBanners
     * @secure
     */
    galleryGetDashboardBannersList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosGalleryBannerOutputDto[], any>({
        path: `/api/Gallery/GetDashboardBanners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryGetLoginBannersList
     * @request GET:/api/Gallery/GetLoginBanners
     * @secure
     */
    galleryGetLoginBannersList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosGalleryBannerOutputDto[], any>({
        path: `/api/Gallery/GetLoginBanners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gallery
     * @name GalleryGetAllMediaList
     * @request GET:/api/Gallery/GetAllMedia
     * @secure
     */
    galleryGetAllMediaList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosGalleryGalleryOutputDto[], any>({
        path: `/api/Gallery/GetAllMedia`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name InfoList
     * @request GET:/api/info
     * @secure
     */
    infoList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/info`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationAddAllUnSyncStudentsToQueueList
     * @request GET:/api/Integration/AddAllUnSyncStudentsToQueue
     * @secure
     */
    integrationAddAllUnSyncStudentsToQueueList: (
      query?: {
        /** @format int32 */
        limit?: number;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Integration/AddAllUnSyncStudentsToQueue`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationUserForCrmList
     * @request GET:/api/Integration/UserForCrm
     * @secure
     */
    integrationUserForCrmList: (
      query?: {
        /** @format date-time */
        UpdatedAfter?: string;
        /** @format date-time */
        CreatedAfter?: string;
        /** @format uuid */
        StudentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionServerDtosIntegrationUserForCrmResponse, any>({
        path: `/api/Integration/UserForCrm`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Interrupt
     * @name InterruptList
     * @request GET:/api/Interrupt
     * @secure
     */
    interruptList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInterruptsInterruptOutputDto[], any>({
        path: `/api/Interrupt`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Interrupt
     * @name InterruptCreate
     * @request POST:/api/Interrupt
     * @secure
     */
    interruptCreate: (
      data: FusionSharedDtosInterruptsInterruptInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInterruptsInterruptOutputDto, any>({
        path: `/api/Interrupt`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceGetInvoiceByIdDetail
     * @request GET:/api/Invoice/GetInvoiceById/{id}
     * @secure
     */
    invoiceGetInvoiceByIdDetail: (id: string, params: RequestParams = {}) =>
      this.request<FusionSharedDtosInvoiceInvoiceOutputDto, any>({
        path: `/api/Invoice/GetInvoiceById/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceCreate
     * @request POST:/api/Invoice
     * @secure
     */
    invoiceCreate: (
      data: FusionSharedDtosInvoiceInvoiceInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceInvoiceInputDto, any>({
        path: `/api/Invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingCreate
     * @request POST:/api/Meeting
     * @secure
     */
    meetingCreate: (
      data: FusionSharedDtosMeetingMeetingInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto, any>({
        path: `/api/Meeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingUpdate
     * @request PUT:/api/Meeting
     * @secure
     */
    meetingUpdate: (
      data: FusionSharedDtosMeetingMeetingInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto, any>({
        path: `/api/Meeting`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingRescheduleMeetingUpdate
     * @request PUT:/api/Meeting/RescheduleMeeting
     * @secure
     */
    meetingRescheduleMeetingUpdate: (
      data: FusionSharedDtosMeetingMeetingInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto, any>({
        path: `/api/Meeting/RescheduleMeeting`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingDetail
     * @request GET:/api/Meeting/{id}
     * @secure
     */
    meetingDetail: (id: string, params: RequestParams = {}) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto, any>({
        path: `/api/Meeting/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingDelete
     * @request DELETE:/api/Meeting/{id}
     * @secure
     */
    meetingDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Meeting/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetDetail
     * @request GET:/api/Meeting/Get/{id}/{studentId}
     * @secure
     */
    meetingGetDetail: (
      id: string,
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto, any>({
        path: `/api/Meeting/Get/${id}/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetUserMeetingList
     * @request GET:/api/Meeting/GetUserMeeting
     * @secure
     */
    meetingGetUserMeetingList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/Meeting/GetUserMeeting`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingBookedFirstMeetingDetail
     * @request GET:/api/Meeting/BookedFirstMeeting/{studentId}
     * @secure
     */
    meetingBookedFirstMeetingDetail: (
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/Meeting/BookedFirstMeeting/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetUpComingMeetingList
     * @request GET:/api/Meeting/GetUpComingMeeting
     * @secure
     */
    meetingGetUpComingMeetingList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto[], any>({
        path: `/api/Meeting/GetUpComingMeeting`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetUpComingMeetingDetail
     * @request GET:/api/Meeting/GetUpComingMeeting/{studentId}
     * @secure
     */
    meetingGetUpComingMeetingDetail: (
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto[], any>({
        path: `/api/Meeting/GetUpComingMeeting/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingAllowedToRescheduleMeetingList
     * @request GET:/api/Meeting/AllowedToRescheduleMeeting
     * @secure
     */
    meetingAllowedToRescheduleMeetingList: (
      query?: {
        /** @format uuid */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosMeetingRescheduleMeetingInviteeOutputDto,
        any
      >({
        path: `/api/Meeting/AllowedToRescheduleMeeting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingRescheduleMeetingInviteeCreate
     * @request POST:/api/Meeting/RescheduleMeetingInvitee
     * @secure
     */
    meetingRescheduleMeetingInviteeCreate: (
      data: FusionSharedDtosMeetingRescheduleMeetingInviteeInputDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Meeting/RescheduleMeetingInvitee`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingAddOrRescheduleMeetingInviteeCreate
     * @request POST:/api/Meeting/AddOrRescheduleMeetingInvitee
     * @secure
     */
    meetingAddOrRescheduleMeetingInviteeCreate: (
      data: FusionSharedDtosMeetingAddOrRescheduleMeetingInviteeInputDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosMeetingAddOrRescheduleMeetingInviteeOutputDto,
        any
      >({
        path: `/api/Meeting/AddOrRescheduleMeetingInvitee`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetAvailableMeetingsDetail
     * @request GET:/api/Meeting/GetAvailableMeetings/{studentId}
     * @secure
     */
    meetingGetAvailableMeetingsDetail: (
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingTimeDto[], any>({
        path: `/api/Meeting/GetAvailableMeetings/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetTeacherMeetingsList
     * @request GET:/api/Meeting/GetTeacherMeetings
     * @secure
     */
    meetingGetTeacherMeetingsList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto[], any>({
        path: `/api/Meeting/GetTeacherMeetings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetAllMeetingsList
     * @request GET:/api/Meeting/GetAllMeetings
     * @secure
     */
    meetingGetAllMeetingsList: (
      query?: {
        meetingType?: FusionSharedEnumsMeetingType;
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMeetingMeetingOutputDto[], any>({
        path: `/api/Meeting/GetAllMeetings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingAddInviteeToMeetingCreate
     * @request POST:/api/Meeting/AddInviteeToMeeting
     * @secure
     */
    meetingAddInviteeToMeetingCreate: (
      data: FusionSharedDtosMeetingMeetingTimeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Meeting/AddInviteeToMeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingStartJitsiMeetingUpdate
     * @request PUT:/api/Meeting/StartJitsiMeeting/{id}
     * @secure
     */
    meetingStartJitsiMeetingUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Meeting/StartJitsiMeeting/${id}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetMeetingUrlDetail
     * @request GET:/api/Meeting/GetMeetingUrl/{id}
     * @secure
     */
    meetingGetMeetingUrlDetail: (id: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/Meeting/GetMeetingUrl/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetMeetingUrlDetail2
     * @request GET:/api/Meeting/GetMeetingUrl/{id}/{studentId}
     * @originalName meetingGetMeetingUrlDetail
     * @duplicate
     * @secure
     */
    meetingGetMeetingUrlDetail2: (
      id: string,
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/Meeting/GetMeetingUrl/${id}/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetTestMeetingUrlList
     * @request GET:/api/Meeting/GetTestMeetingUrl
     * @secure
     */
    meetingGetTestMeetingUrlList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/Meeting/GetTestMeetingUrl`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetAllAgeCategoriesList
     * @request GET:/api/Meeting/GetAllAgeCategories
     * @secure
     */
    meetingGetAllAgeCategoriesList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosMeetingAgeCategoryOutputDto[], any>({
        path: `/api/Meeting/GetAllAgeCategories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetRecordedBbbUrlDetail
     * @request GET:/api/Meeting/GetRecordedBbbUrl/{meetingId}
     * @secure
     */
    meetingGetRecordedBbbUrlDetail: (
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/Meeting/GetRecordedBbbUrl/${meetingId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name NotificationForceSendDetail
     * @request GET:/api/Notification/ForceSend/{id}
     * @secure
     */
    notificationForceSendDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Notification/ForceSend/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsFakeDataCreate
     * @request POST:/api/Nps/FakeData
     * @secure
     */
    npsFakeDataCreate: (
      data: BookingManagementHandlersNpsFakerCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/FakeData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name PostApi
     * @request POST:/api/Nps
     * @secure
     */
    postApi: (
      data: BookingHandlersCommandsCreateNpsCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsSubmitNpsCreate
     * @request POST:/api/Nps/SubmitNps
     * @secure
     */
    npsSubmitNpsCreate: (
      data: BookingHandlersCommandsCreateNpsFormCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/SubmitNps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsSubmitNpsByAdminCreate
     * @request POST:/api/Nps/SubmitNpsByAdmin
     * @secure
     */
    npsSubmitNpsByAdminCreate: (
      data: BookingHandlersCommandsCreateNpsFormCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/SubmitNpsByAdmin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsNotifyNpsCreate
     * @request POST:/api/Nps/NotifyNps
     * @secure
     */
    npsNotifyNpsCreate: (
      data: BookingHandlersCommandsNotifyNpsCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/NotifyNps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsNotifyNpsHistoryList
     * @request GET:/api/Nps/NotifyNpsHistory
     * @secure
     */
    npsNotifyNpsHistoryList: (
      query?: {
        query?: BookingManagementCQRSQueriesGetNotifyNpsHistoriesQuery;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/NotifyNpsHistory`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsNpsFormList
     * @request GET:/api/Nps/NpsForm
     * @secure
     */
    npsNpsFormList: (
      query?: {
        ObjectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosNpsGetNpsFormByObjectIdResponse, any>({
        path: `/api/Nps/NpsForm`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsNpsPostponeCreate
     * @request POST:/api/Nps/NpsPostpone
     * @secure
     */
    npsNpsPostponeCreate: (
      data: BookingHandlersCommandsCreateNpsPostponeCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/NpsPostpone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsAvailableNpsFormListForTimeSlotCreate
     * @request POST:/api/Nps/AvailableNpsFormListForTimeSlot
     * @secure
     */
    npsAvailableNpsFormListForTimeSlotCreate: (
      data: BookingManagementCQRSQueriesGetNpsListByBusinessUserQuery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/AvailableNpsFormListForTimeSlot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsPendingNpsFormList
     * @request GET:/api/Nps/PendingNpsForm
     * @secure
     */
    npsPendingNpsFormList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        IsAdmin?: boolean;
        /** @format uuid */
        StudentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosNpsGetPendingNpsFormByUserResponse, any>({
        path: `/api/Nps/PendingNpsForm`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsPendingNpsFormByBusinessUserDetail
     * @request GET:/api/Nps/PendingNpsFormByBusinessUser/{parentId}
     * @secure
     */
    npsPendingNpsFormByBusinessUserDetail: (
      parentId: string,
      query?: {
        /** @format uuid */
        UserId?: string;
        IsAdmin?: boolean;
        /** @format uuid */
        StudentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/PendingNpsFormByBusinessUser/${parentId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsParseObjectIdList
     * @request GET:/api/Nps/ParseObjectId
     * @secure
     */
    npsParseObjectIdList: (
      query?: {
        objectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Nps/ParseObjectId`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nps
     * @name NpsSyncNpsFormStudentIdList
     * @request GET:/api/Nps/SyncNpsFormStudentId
     * @secure
     */
    npsSyncNpsFormStudentIdList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Nps/SyncNpsFormStudentId`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetStudentInfoList
     * @request GET:/api/ParentReport/GetStudentInfo
     * @secure
     */
    parentReportGetStudentInfoList: (
      query?: {
        /** @format uuid */
        studentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleStudentResponseDto, any>({
        path: `/api/ParentReport/GetStudentInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetStudentPerformanceList
     * @request GET:/api/ParentReport/GetStudentPerformance
     * @secure
     */
    parentReportGetStudentPerformanceList: (
      query?: {
        /** @format uuid */
        ChildId?: string;
        /** @format int32 */
        CourseId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleStudentPerformanceResponseDto[], any>({
        path: `/api/ParentReport/GetStudentPerformance`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetStudentLoginLogList
     * @request GET:/api/ParentReport/GetStudentLoginLog
     * @secure
     */
    parentReportGetStudentLoginLogList: (
      query?: {
        /** @format uuid */
        studentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleStudentLoginLogResponseDto[], any>({
        path: `/api/ParentReport/GetStudentLoginLog`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetStatusClassAttendanceList
     * @request GET:/api/ParentReport/GetStatusClassAttendance
     * @secure
     */
    parentReportGetStatusClassAttendanceList: (
      query?: {
        /** @format uuid */
        ChildId?: string;
        /** @format int32 */
        CourseId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleClassAttendanceResponseDto[], any>({
        path: `/api/ParentReport/GetStatusClassAttendance`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetTutorContactInfoList
     * @request GET:/api/ParentReport/GetTutorContactInfo
     * @secure
     */
    parentReportGetTutorContactInfoList: (
      query?: {
        /** @format uuid */
        ChildId?: string;
        /** @format int32 */
        CourseId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleTutorContactInfoResponseDto[], any>({
        path: `/api/ParentReport/GetTutorContactInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetUpcomingEventsList
     * @request GET:/api/ParentReport/GetUpcomingEvents
     * @secure
     */
    parentReportGetUpcomingEventsList: (
      query?: {
        /** @format uuid */
        ChildId?: string;
        /** @format int32 */
        CourseId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleUpcomingEventDto[], any>({
        path: `/api/ParentReport/GetUpcomingEvents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParentReport
     * @name ParentReportGetStudentXpList
     * @request GET:/api/ParentReport/GetStudentXp
     * @secure
     */
    parentReportGetStudentXpList: (
      query?: {
        /** @format uuid */
        ChildId?: string;
        /** @format int32 */
        CourseId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosMoodleStudentXpDto, any>({
        path: `/api/ParentReport/GetStudentXp`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPayDetail
     * @request GET:/api/Payment/Pay/{id}
     * @secure
     */
    paymentPayDetail: (
      id: string,
      query?: {
        pspType?: FusionSharedEnumsPspType;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceInvoicePaymentDto, any>({
        path: `/api/Payment/Pay/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentVerifyDetail
     * @request GET:/api/Payment/verify/{id}
     * @secure
     */
    paymentVerifyDetail: (
      id: string,
      query?: {
        MID?: string;
        State?: string;
        Status?: string;
        RRN?: string;
        RefNum?: string;
        ResNum?: string;
        TerminalId?: string;
        TraceNo?: string;
        Amount?: string;
        Wage?: string;
        SecurePan?: string;
        HashedCardNumber?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/verify/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentVerifyCreate
     * @request POST:/api/Payment/verify/{id}
     * @secure
     */
    paymentVerifyCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Payment/verify/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentVerifyPaymentCreate
     * @request POST:/api/Payment/VerifyPayment/{id}
     * @secure
     */
    paymentVerifyPaymentCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Payment/VerifyPayment/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentVerifyPaymentDetail
     * @request GET:/api/Payment/VerifyPayment/{id}
     * @secure
     */
    paymentVerifyPaymentDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Payment/VerifyPayment/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentVerifyPaymentStatusCreate
     * @request POST:/api/Payment/VerifyPayment/{id}/status/{status}
     * @secure
     */
    paymentVerifyPaymentStatusCreate: (
      id: string,
      status: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/VerifyPayment/${id}/status/${status}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentVerifyPaymentStatusDetail
     * @request GET:/api/Payment/VerifyPayment/{id}/status/{status}
     * @secure
     */
    paymentVerifyPaymentStatusDetail: (
      id: string,
      status: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/VerifyPayment/${id}/status/${status}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentSnappPayVerifyPaymentCreate
     * @request POST:/api/Payment/SnappPayVerifyPayment
     * @secure
     */
    paymentSnappPayVerifyPaymentCreate: (
      query?: {
        TransactionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/SnappPayVerifyPayment`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentSnappPayVerifyPaymentList
     * @request GET:/api/Payment/SnappPayVerifyPayment
     * @secure
     */
    paymentSnappPayVerifyPaymentList: (
      query?: {
        TransactionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/SnappPayVerifyPayment`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetTransactionHistoriesList
     * @request GET:/api/Payment/GetTransactionHistories
     * @secure
     */
    paymentGetTransactionHistoriesList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosInvoiceTransactionHistoryDto[], any>({
        path: `/api/Payment/GetTransactionHistories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetStudentTransactionHistoriesDetail
     * @request GET:/api/Payment/GetStudentTransactionHistories/{studentId}
     * @secure
     */
    paymentGetStudentTransactionHistoriesDetail: (
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceTransactionHistoryDto[], any>({
        path: `/api/Payment/GetStudentTransactionHistories/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetInvoiceByPspSadadIdDetail
     * @request GET:/api/Payment/GetInvoiceByPspSadadId/{id}
     * @secure
     */
    paymentGetInvoiceByPspSadadIdDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceInvoiceOutputDto, any>({
        path: `/api/Payment/GetInvoiceByPspSadadId/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetVerifiedPspSadadByIdDetail
     * @request GET:/api/Payment/GetVerifiedPspSadadById/{id}
     * @secure
     */
    paymentGetVerifiedPspSadadByIdDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPspSuccessPspSadadLogOutputDto, any>({
        path: `/api/Payment/GetVerifiedPspSadadById/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetPaymentErrorByPspSadadIdDetail
     * @request GET:/api/Payment/GetPaymentErrorByPspSadadId/{id}
     * @secure
     */
    paymentGetPaymentErrorByPspSadadIdDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPspPspErrorDto, any>({
        path: `/api/Payment/GetPaymentErrorByPspSadadId/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentGetResultByLogIdDetail
     * @request GET:/api/Payment/GetResultByLogId/{id}
     * @secure
     */
    paymentGetResultByLogIdDetail: (
      id: string,
      query?: {
        /** @format uuid */
        logId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPspPspResultOutputDto, any>({
        path: `/api/Payment/GetResultByLogId/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPayAgainDetail
     * @request GET:/api/Payment/PayAgain/{logId}
     * @secure
     */
    paymentPayAgainDetail: (logId: string, params: RequestParams = {}) =>
      this.request<FusionSharedDtosInvoiceInvoicePaymentDto, any>({
        path: `/api/Payment/PayAgain/${logId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentSnappPayListCreate
     * @request POST:/api/Payment/SnappPayList
     * @secure
     */
    paymentSnappPayListCreate: (
      data: FusionSharedDtosInvoiceSnappPayTransactionHistoryRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceSnappPayTransactionHistoryDto[], any>(
        {
          path: `/api/Payment/SnappPayList`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCancelSnappPayCreate
     * @request POST:/api/Payment/CancelSnappPay
     * @secure
     */
    paymentCancelSnappPayCreate: (
      data: FusionSharedDtosInvoiceSnappPayCancelRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceSnappPayCancelResponse, any>({
        path: `/api/Payment/CancelSnappPay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCreatePaymentLinkCreate
     * @request POST:/api/Payment/CreatePaymentLink
     * @secure
     */
    paymentCreatePaymentLinkCreate: (
      data: FusionSharedDtosInvoiceCreatePaymentLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceCreatePaymentLinkResponse, any>({
        path: `/api/Payment/CreatePaymentLink`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCreatePaymentLinkForExistingCreate
     * @request POST:/api/Payment/CreatePaymentLinkForExisting
     * @secure
     */
    paymentCreatePaymentLinkForExistingCreate: (
      data: FusionSharedDtosInvoiceCreatePaymentLinkForExistingRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceCreatePaymentLinkResponse, any>({
        path: `/api/Payment/CreatePaymentLinkForExisting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentCreatePaymentLinkByUserCreate
     * @request POST:/api/Payment/CreatePaymentLinkByUser
     * @secure
     */
    paymentCreatePaymentLinkByUserCreate: (
      data: FusionSharedDtosInvoiceCreatePaymentLinkByUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceCreatePaymentLinkResponse, any>({
        path: `/api/Payment/CreatePaymentLinkByUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPaymentLinkList
     * @request GET:/api/Payment/PaymentLink
     * @secure
     */
    paymentPaymentLinkList: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceGetPaymentLinkResponse, any>({
        path: `/api/Payment/PaymentLink`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPaymentLinkInfoList
     * @request GET:/api/Payment/PaymentLinkInfo
     * @secure
     */
    paymentPaymentLinkInfoList: (
      query?: {
        /** @format uuid */
        SupplyId?: string;
        DiscountCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosInvoiceGetPaymentLinkInfoResponse, any>({
        path: `/api/Payment/PaymentLinkInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPaymentLinkRedirectToGatewayList
     * @request GET:/api/Payment/PaymentLinkRedirectToGateway
     * @secure
     */
    paymentPaymentLinkRedirectToGatewayList: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/PaymentLinkRedirectToGateway`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPaymentLinkListList
     * @request GET:/api/Payment/PaymentLinkList
     * @secure
     */
    paymentPaymentLinkListList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosInvoicePaymentLinkDto[], any>({
        path: `/api/Payment/PaymentLinkList`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentPaymentsList
     * @request GET:/api/Payment/Payments
     * @secure
     */
    paymentPaymentsList: (
      query?: {
        /** @format int32 */
        numberFrom?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/Payments`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentFakeList
     * @request GET:/api/Payment/Fake
     * @secure
     */
    paymentFakeList: (
      query?: {
        token?: string;
        isOk?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Payment/Fake`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Placement
     * @name PlacementGetHistoryByUserIdList
     * @request GET:/api/Placement/GetHistoryByUserId
     * @secure
     */
    placementGetHistoryByUserIdList: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPlacementGetHistoryListResponse[], any>({
        path: `/api/Placement/GetHistoryByUserId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Placement
     * @name PlacementGetAvailableCourseList
     * @request GET:/api/Placement/GetAvailableCourse
     * @secure
     */
    placementGetAvailableCourseList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        PlacementType?: FusionSharedEnumsPlacementType;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPlacementGetAvailableCourseResponse, any>({
        path: `/api/Placement/GetAvailableCourse`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Placement
     * @name PlacementCreateByBusinessUserCreate
     * @request POST:/api/Placement/CreateByBusinessUser
     * @secure
     */
    placementCreateByBusinessUserCreate: (
      data: FusionSharedDtosPlacementCreateByBusinessUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPlacementCreateByBusinessUserResponse, any>({
        path: `/api/Placement/CreateByBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionAddPromotionToInvoiceUpdate
     * @request PUT:/api/Promotion/AddPromotionToInvoice
     * @secure
     */
    promotionAddPromotionToInvoiceUpdate: (
      data: FusionSharedDtosPromotionPromotionCalcInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionPromotionCalcOutputDto, any>({
        path: `/api/Promotion/AddPromotionToInvoice`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionCreatePromotionListCreate
     * @request POST:/api/Promotion/CreatePromotionList
     * @secure
     */
    promotionCreatePromotionListCreate: (
      data: FusionSharedDtosPromotionPromotionInputDto[],
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionPromotionOutputDto[], any>({
        path: `/api/Promotion/CreatePromotionList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionCreate
     * @request POST:/api/Promotion
     * @secure
     */
    promotionCreate: (
      data: FusionSharedDtosPromotionPromotionInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionPromotionOutputDto, any>({
        path: `/api/Promotion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionUpdate
     * @request PUT:/api/Promotion
     * @secure
     */
    promotionUpdate: (
      data: FusionSharedDtosPromotionPromotionInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionPromotionOutputDto, any>({
        path: `/api/Promotion`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionGetPromotionsList
     * @request GET:/api/Promotion/GetPromotions
     * @secure
     */
    promotionGetPromotionsList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionPromotionOutputDto[], any>({
        path: `/api/Promotion/GetPromotions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionDelete
     * @request DELETE:/api/Promotion/{id}
     * @secure
     */
    promotionDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Promotion/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionGetReferralList
     * @request GET:/api/Promotion/GetReferral
     * @secure
     */
    promotionGetReferralList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosPromotionReferralOutputDto, any>({
        path: `/api/Promotion/GetReferral`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionCreateReferralCreate
     * @request POST:/api/Promotion/CreateReferral
     * @secure
     */
    promotionCreateReferralCreate: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosPromotionReferralOutputDto, any>({
        path: `/api/Promotion/CreateReferral`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionClaimReferralGiftCreate
     * @request POST:/api/Promotion/ClaimReferralGift
     * @secure
     */
    promotionClaimReferralGiftCreate: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosPromotionReferralOutputDto, any>({
        path: `/api/Promotion/ClaimReferralGift`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionGetAllReferralsList
     * @request GET:/api/Promotion/GetAllReferrals
     * @secure
     */
    promotionGetAllReferralsList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionReferralOutputDto[], any>({
        path: `/api/Promotion/GetAllReferrals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionBurnReferralCreate
     * @request POST:/api/Promotion/BurnReferral
     * @secure
     */
    promotionBurnReferralCreate: (
      data: FusionSharedDtosPromotionBurnReferralInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionReferralOutputDto, any>({
        path: `/api/Promotion/BurnReferral`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Promotion
     * @name PromotionGetReferrerListByReferralIdDetail
     * @request GET:/api/Promotion/GetReferrerListByReferralId/{ReferralId}
     * @secure
     */
    promotionGetReferrerListByReferralIdDetail: (
      referralId: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosPromotionReferrerOutputDto[], any>({
        path: `/api/Promotion/GetReferrerListByReferralId/${referralId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportActiveStudentsList
     * @request GET:/api/Report/active-students
     * @secure
     */
    reportActiveStudentsList: (
      query?: {
        Token?: string;
        /** @format date-time */
        StartAt?: string;
        ExcludeContractBaseUser?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Report/active-students`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportChurnedStudentList
     * @request GET:/api/Report/churned-student
     * @secure
     */
    reportChurnedStudentList: (
      query?: {
        Token?: string;
        /** @format date-time */
        StartAt?: string;
        /** @format date-time */
        EndAt?: string;
        ExcludeContractBaseUser?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Report/churned-student`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportChangePlanStudentList
     * @request GET:/api/Report/change-plan-student
     * @secure
     */
    reportChangePlanStudentList: (
      query?: {
        Token?: string;
        /** @format date-time */
        StartAt?: string;
        /** @format date-time */
        EndAt?: string;
        ExcludeContractBaseUser?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Report/change-plan-student`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportNewStudentList
     * @request GET:/api/Report/new-student
     * @secure
     */
    reportNewStudentList: (
      query?: {
        Token?: string;
        /** @format date-time */
        StartAt?: string;
        /** @format date-time */
        EndAt?: string;
        ExcludeContractBaseUser?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Report/new-student`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportStudentStatisticsList
     * @request GET:/api/Report/student-statistics
     * @secure
     */
    reportStudentStatisticsList: (
      query?: {
        Token?: string;
        ResetCache?: boolean;
        ExcludeContractBaseUser?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Report/student-statistics`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportStudentSubscriptionRangeCreate
     * @request POST:/api/Report/student-subscription-range
     * @secure
     */
    reportStudentSubscriptionRangeCreate: (
      data: FusionServerServicesReportStudentSubscriptionRangeRequestQuery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Report/student-subscription-range`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shad
     * @name ShadLoginList
     * @request GET:/api/Shad/login
     * @secure
     */
    shadLoginList: (
      query?: {
        UserId?: string;
        Token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Shad/login`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shad
     * @name ShadEntryList
     * @request GET:/api/Shad/entry
     * @secure
     */
    shadEntryList: (
      query?: {
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Shad/entry`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortenUrl
     * @name ShortenUrlCreate
     * @request POST:/api/ShortenUrl
     * @secure
     */
    shortenUrlCreate: (
      data: FusionSharedDtosShortenUrlCreateShortenUrlRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosShortenUrlCreateShortenUrlResponse, any>({
        path: `/api/ShortenUrl`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortenUrl
     * @name ShortenUrlList
     * @request GET:/api/ShortenUrl
     * @secure
     */
    shortenUrlList: (
      query?: {
        /** @format uuid */
        Id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosShortenUrlListShortenUrlResponse[], any>({
        path: `/api/ShortenUrl`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortenUrl
     * @name ShortenUrlUpdate
     * @request PUT:/api/ShortenUrl
     * @secure
     */
    shortenUrlUpdate: (
      data: FusionSharedDtosShortenUrlUpdateShortenUrlRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosShortenUrlUpdateShortenUrlResponse, any>({
        path: `/api/ShortenUrl`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShortenUrl
     * @name ShortenUrlGenerateNewTokenList
     * @request GET:/api/ShortenUrl/GenerateNewToken
     * @secure
     */
    shortenUrlGenerateNewTokenList: (
      query?: {
        /**
         * @format int32
         * @default 10
         */
        shortCodeLength?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosShortenUrlTokenShortenUrlResponse, any>({
        path: `/api/ShortenUrl/GenerateNewToken`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionGetValidPlansDetail
     * @request GET:/api/Subscription/GetValidPlans/{userId}
     * @secure
     */
    subscriptionGetValidPlansDetail: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosSubscriptionSubscriptionPlanDto[], any>({
        path: `/api/Subscription/GetValidPlans/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionGetCheapestPlanCreate
     * @request POST:/api/Subscription/GetCheapestPlan
     * @secure
     */
    subscriptionGetCheapestPlanCreate: (
      data: FusionSharedDtosSubscriptionCheapestPlanRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosSubscriptionSubscriptionPlanDto, any>({
        path: `/api/Subscription/GetCheapestPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionUpdate
     * @request PUT:/api/Subscription
     * @secure
     */
    subscriptionUpdate: (
      query?: {
        /** @format uuid */
        key?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Subscription`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionGetAllUserSubscriptionsList
     * @request GET:/api/Subscription/GetAllUserSubscriptions
     * @secure
     */
    subscriptionGetAllUserSubscriptionsList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosSubscriptionUserSubscriptionHistoryDto[],
        any
      >({
        path: `/api/Subscription/GetAllUserSubscriptions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionGetUserSubscriptionsForBookingCreate
     * @request POST:/api/Subscription/GetUserSubscriptionsForBooking
     * @secure
     */
    subscriptionGetUserSubscriptionsForBookingCreate: (
      data: FusionSharedDtosSubscriptionFilterSubscriptionForBookingDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosSubscriptionFilterSubscriptionForBookingResultDto[],
        any
      >({
        path: `/api/Subscription/GetUserSubscriptionsForBooking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionGetAllList
     * @request GET:/api/Subscription/GetAll
     * @secure
     */
    subscriptionGetAllList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosSubscriptionSubscriptionPlanInfoDto[], any>({
        path: `/api/Subscription/GetAll`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionPlanUpdate
     * @request PUT:/api/Subscription/plan
     * @secure
     */
    subscriptionPlanUpdate: (
      data: FusionSharedDtosSubscriptionSubscriptionPlanUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Subscription/plan`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name SubscriptionSubscriptionErrorList
     * @request GET:/api/Subscription/SubscriptionError
     * @secure
     */
    subscriptionSubscriptionErrorList: (
      query?: {
        /** @format date-time */
        from?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Subscription/SubscriptionError`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name MinimalApiSampleDetail
     * @request GET:/api/minimal-api-sample/{routeParameter}
     * @secure
     */
    minimalApiSampleDetail: (
      routeParameter: string,
      query: {
        queryStringParameter: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TypeFAnonymousType1152SystemStringSystemString, any>({
        path: `/api/minimal-api-sample/${routeParameter}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotFakeDataCreate
     * @request POST:/api/TimeSlot/FakeData
     * @secure
     */
    timeSlotFakeDataCreate: (
      data: BookingManagementHandlersTimeSlotFakerCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/FakeData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotFilterCreate
     * @request POST:/api/TimeSlot/Filter
     * @secure
     */
    timeSlotFilterCreate: (
      data: BookingManagementHandlersFilterTimeSlotQuery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/Filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotCreate
     * @request POST:/api/TimeSlot
     * @secure
     */
    timeSlotCreate: (
      data: BookingManagementHandlersCreateTimeSlotCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotAssignToStudentCreate
     * @request POST:/api/TimeSlot/AssignToStudent
     * @secure
     */
    timeSlotAssignToStudentCreate: (
      data: BookingManagementHandlersAssignTimeSlotToStudentCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/AssignToStudent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotByTutorIdDetail
     * @request GET:/api/TimeSlot/ByTutorId/{tutorId}
     * @secure
     */
    timeSlotByTutorIdDetail: (tutorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/TimeSlot/ByTutorId/${tutorId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotSyncWithMoodleCreate
     * @request POST:/api/TimeSlot/SyncWithMoodle
     * @secure
     */
    timeSlotSyncWithMoodleCreate: (
      data: BookingManagementHandlersSyncTimeSlotWithMoodleGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/SyncWithMoodle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotGetListCreate
     * @request POST:/api/TimeSlot/GetList
     * @secure
     */
    timeSlotGetListCreate: (
      data: BookingManagementHandlersGetTimeSlotListQuery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/GetList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotGetByIdDetail
     * @request GET:/api/TimeSlot/GetById/{id}
     * @secure
     */
    timeSlotGetByIdDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/TimeSlot/GetById/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotGetStudentsByIdDetail
     * @request GET:/api/TimeSlot/GetStudentsById/{id}
     * @secure
     */
    timeSlotGetStudentsByIdDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/TimeSlot/GetStudentsById/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotEndTimeSlotCreate
     * @request POST:/api/TimeSlot/EndTimeSlot
     * @secure
     */
    timeSlotEndTimeSlotCreate: (
      data: BookingManagementHandlersEndTimeSlotGroupCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/EndTimeSlot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotUnAssignStudentCreate
     * @request POST:/api/TimeSlot/UnAssignStudent
     * @secure
     */
    timeSlotUnAssignStudentCreate: (
      data: BookingManagementHandlersUnAssignTimeSlotStudentCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/UnAssignStudent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotUpdateTimeSlotTutorCreate
     * @request POST:/api/TimeSlot/UpdateTimeSlotTutor
     * @secure
     */
    timeSlotUpdateTimeSlotTutorCreate: (
      data: BookingManagementHandlersUpdateTimeSlotTutorCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/UpdateTimeSlotTutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotTimeSlotUpdateTimeCreate
     * @request POST:/api/TimeSlot/TimeSlotUpdateTime
     * @secure
     */
    timeSlotTimeSlotUpdateTimeCreate: (
      data: BookingManagementHandlersUpdateTimeSlotTimeCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/TimeSlotUpdateTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotTimeSlotAvailableTutorCreate
     * @request POST:/api/TimeSlot/TimeSlotAvailableTutor
     * @secure
     */
    timeSlotTimeSlotAvailableTutorCreate: (
      data: BookingManagementHandlersGetAvailableTutorForTimeSlotListQuery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/TimeSlotAvailableTutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotReAssignStudentCreate
     * @request POST:/api/TimeSlot/ReAssignStudent
     * @secure
     */
    timeSlotReAssignStudentCreate: (
      data: FusionSharedDtosBookingTimeSlotReAssignStudentRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/ReAssignStudent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TimeSlot
     * @name TimeSlotChangeMinCapacityCreate
     * @request POST:/api/TimeSlot/ChangeMinCapacity
     * @secure
     */
    timeSlotChangeMinCapacityCreate: (
      data: FusionSharedDtosBookingTimeSlotChangeMinCapacityRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TimeSlot/ChangeMinCapacity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TokenManagement
     * @name TokenManagementVandarTokenCreate
     * @request POST:/api/TokenManagement/vandar-token
     * @secure
     */
    tokenManagementVandarTokenCreate: (
      query?: {
        accessToken?: string;
        refreshToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/TokenManagement/vandar-token`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TokenManagement
     * @name TokenManagementRefreshVandarTokenCreate
     * @request POST:/api/TokenManagement/refresh-vandar-token
     * @secure
     */
    tokenManagementRefreshVandarTokenCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/TokenManagement/refresh-vandar-token`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorSeedCreate
     * @request POST:/api/Tutor/seed
     * @secure
     */
    tutorSeedCreate: (
      data: BookingManagementHandlersTutorSeedCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Tutor/seed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorCreate
     * @request POST:/api/Tutor
     * @secure
     */
    tutorCreate: (
      data: BookingManagementHandlersGetTutorsWithAdvancedFiltersQuery,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Tutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorPartialUpdate
     * @request PATCH:/api/Tutor
     * @secure
     */
    tutorPartialUpdate: (
      data: BookingManagementHandlersUpdateTutorCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Tutor`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorSyncWithMoodleCreate
     * @request POST:/api/Tutor/SyncWithMoodle
     * @secure
     */
    tutorSyncWithMoodleCreate: (
      data: BookingManagementHandlersSyncTutorsWithMoodleCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/Tutor/SyncWithMoodle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorDetail
     * @request GET:/api/Tutor/{id}
     * @secure
     */
    tutorDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Tutor/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorProfileList
     * @request GET:/api/Tutor/Profile
     * @secure
     */
    tutorProfileList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Tutor/Profile`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tutor
     * @name TutorLastBookingList
     * @request GET:/api/Tutor/LastBooking
     * @secure
     */
    tutorLastBookingList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Tutor/LastBooking`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetCurrentUserList
     * @request GET:/api/User/GetCurrentUser
     * @secure
     */
    userGetCurrentUserList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosAccountUserDto, any>({
        path: `/api/User/GetCurrentUser`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetCurrentUserNameList
     * @request GET:/api/User/GetCurrentUserName
     * @secure
     */
    userGetCurrentUserNameList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/User/GetCurrentUserName`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserChildrenList
     * @request GET:/api/User/GetUserChildren
     * @secure
     */
    userGetUserChildrenList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosAccountUserDto[], any>({
        path: `/api/User/GetUserChildren`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserChildrenDetail
     * @request GET:/api/User/GetUserChildren/{userId}
     * @secure
     */
    userGetUserChildrenDetail: (userId: string, params: RequestParams = {}) =>
      this.request<FusionSharedDtosAccountUserDto[], any>({
        path: `/api/User/GetUserChildren/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserChildByIdDetail
     * @request GET:/api/User/GetUserChildById/{childId}
     * @secure
     */
    userGetUserChildByIdDetail: (childId: string, params: RequestParams = {}) =>
      this.request<FusionSharedDtosAccountUserDto, any>({
        path: `/api/User/GetUserChildById/${childId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserDetail
     * @request GET:/api/User/GetUser/{userId}
     * @secure
     */
    userGetUserDetail: (userId: string, params: RequestParams = {}) =>
      this.request<FusionSharedDtosAccountUserDto, any>({
        path: `/api/User/GetUser/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAllTeachersList
     * @request GET:/api/User/GetAllTeachers
     * @secure
     */
    userGetAllTeachersList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosAccountUserDto[], any>({
        path: `/api/User/GetAllTeachers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserCompleteRegistrationUpdate
     * @request PUT:/api/User/CompleteRegistration
     * @secure
     */
    userCompleteRegistrationUpdate: (
      data: FusionSharedDtosAccountEditUserDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserUserOutputDto, any>({
        path: `/api/User/CompleteRegistration`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUpdateUserFullNameUpdate
     * @request PUT:/api/User/UpdateUserFullName
     * @secure
     */
    userUpdateUserFullNameUpdate: (
      data: FusionSharedDtosAccountEditUserFullNameDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/User/UpdateUserFullName`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUpdateUserNationalCodeUpdate
     * @request PUT:/api/User/UpdateUserNationalCode
     * @secure
     */
    userUpdateUserNationalCodeUpdate: (
      data: FusionSharedDtosAccountEditUserNationalCodeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/User/UpdateUserNationalCode`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserByNationalCodeDetail
     * @request GET:/api/User/GetUserByNationalCode/{nationalCode}
     * @secure
     */
    userGetUserByNationalCodeDetail: (
      nationalCode: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosAccountUserDto, any>({
        path: `/api/User/GetUserByNationalCode/${nationalCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetCurrentUserMainRolesList
     * @request GET:/api/User/GetCurrentUserMainRoles
     * @secure
     */
    userGetCurrentUserMainRolesList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosUserUserMainRolesDto, any>({
        path: `/api/User/GetCurrentUserMainRoles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSetSelectedUserTypeCreate
     * @request POST:/api/User/SetSelectedUserType
     * @secure
     */
    userSetSelectedUserTypeCreate: (
      data: FusionSharedDtosUserSetSelectedUserTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/User/SetSelectedUserType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserIsUserLimitedDetail
     * @request GET:/api/User/IsUserLimited/{studentId}
     * @secure
     */
    userIsUserLimitedDetail: (studentId: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/User/IsUserLimited/${studentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSignInToMoodleDetail
     * @request GET:/api/User/SignInToMoodle/{studentId}
     * @secure
     */
    userSignInToMoodleDetail: (
      studentId: string,
      query?: {
        redirectUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/User/SignInToMoodle/${studentId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGoToMoodleDetail
     * @request GET:/api/User/GoToMoodle/{section}
     * @secure
     */
    userGoToMoodleDetail: (
      section: string,
      query?: {
        /** @format uuid */
        studentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/User/GoToMoodle/${section}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAllStudentsList
     * @request GET:/api/User/GetAllStudents
     * @secure
     */
    userGetAllStudentsList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserUserOutputDto[], any>({
        path: `/api/User/GetAllStudents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetStudentsInfoList
     * @request GET:/api/User/GetStudentsInfo
     * @secure
     */
    userGetStudentsInfoList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserUserOutputDto[], any>({
        path: `/api/User/GetStudentsInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserUpdateUserInfoUpdate
     * @request PUT:/api/User/UpdateUserInfo
     * @secure
     */
    userUpdateUserInfoUpdate: (
      data: FusionSharedDtosPromotionUserInputDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserUserOutputDto, any>({
        path: `/api/User/UpdateUserInfo`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserIsForceToAdjustInformationList
     * @request GET:/api/User/IsForceToAdjustInformation
     * @secure
     */
    userIsForceToAdjustInformationList: (
      query?: {
        /** @format uuid */
        StudentUserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/User/IsForceToAdjustInformation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAdjustInformationCreate
     * @request POST:/api/User/AdjustInformation
     * @secure
     */
    userAdjustInformationCreate: (
      data: FusionSharedDtosUserAdjustUserInformation,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/User/AdjustInformation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerStudentsListByBusinessUserCreate
     * @request POST:/api/UserManager/StudentsListByBusinessUser
     * @secure
     */
    userManagerStudentsListByBusinessUserCreate: (
      data: FusionSharedDtosUserStudentsListRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserStudentsListResponseDto, any>({
        path: `/api/UserManager/StudentsListByBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerAdminListByBusinessUserList
     * @request GET:/api/UserManager/AdminListByBusinessUser
     * @secure
     */
    userManagerAdminListByBusinessUserList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosUserAdminListResponseDto, any>({
        path: `/api/UserManager/AdminListByBusinessUser`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerUpdateBusinessUserCreate
     * @request POST:/api/UserManager/UpdateBusinessUser
     * @secure
     */
    userManagerUpdateBusinessUserCreate: (
      data: FusionSharedDtosUserBusinessUserUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/UserManager/UpdateBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerCreateBusinessUserCreate
     * @request POST:/api/UserManager/CreateBusinessUser
     * @secure
     */
    userManagerCreateBusinessUserCreate: (
      data: FusionSharedDtosUserBusinessUserCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/UserManager/CreateBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerStudentDeleteByBusinessUserCreate
     * @request POST:/api/UserManager/StudentDeleteByBusinessUser
     * @secure
     */
    userManagerStudentDeleteByBusinessUserCreate: (
      data: FusionSharedDtosUserStudentsDeleteDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/UserManager/StudentDeleteByBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerParentDeleteByBusinessUserCreate
     * @request POST:/api/UserManager/ParentDeleteByBusinessUser
     * @secure
     */
    userManagerParentDeleteByBusinessUserCreate: (
      data: FusionSharedDtosUserParentDeleteDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/UserManager/ParentDeleteByBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerSyncUserCapabilityStatusList
     * @request GET:/api/UserManager/SyncUserCapabilityStatus
     * @secure
     */
    userManagerSyncUserCapabilityStatusList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/UserManager/SyncUserCapabilityStatus`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerSyncUserWithMoodleList
     * @request GET:/api/UserManager/SyncUserWithMoodle
     * @secure
     */
    userManagerSyncUserWithMoodleList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/UserManager/SyncUserWithMoodle`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerUpdateZeblineAttributesList
     * @request GET:/api/UserManager/UpdateZeblineAttributes
     * @secure
     */
    userManagerUpdateZeblineAttributesList: (params: RequestParams = {}) =>
      this.request<FusionSharedDtosZeblineZeblineAttributesResponseDto, any>({
        path: `/api/UserManager/UpdateZeblineAttributes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerStudentProfileByBusinessUserDetail
     * @request GET:/api/UserManager/StudentProfileByBusinessUser/{id}
     * @secure
     */
    userManagerStudentProfileByBusinessUserDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserStudentProfileResponseDto, any>({
        path: `/api/UserManager/StudentProfileByBusinessUser/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerRunNotifyUserSubscriptionList
     * @request GET:/api/UserManager/RunNotifyUserSubscription
     * @secure
     */
    userManagerRunNotifyUserSubscriptionList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/UserManager/RunNotifyUserSubscription`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerSyncCourseCreate
     * @request POST:/api/UserManager/SyncCourse
     * @secure
     */
    userManagerSyncCourseCreate: (
      data: FusionSharedDtosUserSyncUserCurrentCoursesWithMoodleRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosUserSyncUserCurrentCoursesWithMoodleResponseDto,
        any
      >({
        path: `/api/UserManager/SyncCourse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerUpdateUserInformationByBusinessUserCreate
     * @request POST:/api/UserManager/UpdateUserInformationByBusinessUser
     * @secure
     */
    userManagerUpdateUserInformationByBusinessUserCreate: (
      data: FusionSharedDtosUserUpdateUserInformationByBusinessUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosUserUpdateUserInformationByBusinessUserResponse,
        any
      >({
        path: `/api/UserManager/UpdateUserInformationByBusinessUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerUpdateUserMoodleStatusToSuspendedCreate
     * @request POST:/api/UserManager/UpdateUserMoodleStatusToSuspended
     * @secure
     */
    userManagerUpdateUserMoodleStatusToSuspendedCreate: (
      data: FusionSharedDtosUserUpdateUserMoodleStatusToSuspendedRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosUserUpdateUserMoodleStatusToSuspendedResponse,
        any
      >({
        path: `/api/UserManager/UpdateUserMoodleStatusToSuspended`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerUpdateUserMoodleStatusToSuspendingCreate
     * @request POST:/api/UserManager/UpdateUserMoodleStatusToSuspending
     * @secure
     */
    userManagerUpdateUserMoodleStatusToSuspendingCreate: (
      data: FusionSharedDtosUserUpdateUserMoodleStatusToSuspendingRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        FusionSharedDtosUserUpdateUserMoodleStatusToSuspendingResponse,
        any
      >({
        path: `/api/UserManager/UpdateUserMoodleStatusToSuspending`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerRemoveUserSubscriptionCreate
     * @request POST:/api/UserManager/RemoveUserSubscription
     * @secure
     */
    userManagerRemoveUserSubscriptionCreate: (
      data: FusionSharedDtosUserRemoveUserSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserRemoveUserSubscriptionResponse, any>({
        path: `/api/UserManager/RemoveUserSubscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerToggleAllowChangePlanCreate
     * @request POST:/api/UserManager/ToggleAllowChangePlan
     * @secure
     */
    userManagerToggleAllowChangePlanCreate: (
      data: FusionSharedDtosUserAllowChangePlanRequest,
      params: RequestParams = {},
    ) =>
      this.request<FusionSharedDtosUserAllowChangePlanResponse, any>({
        path: `/api/UserManager/ToggleAllowChangePlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManager
     * @name UserManagerMoodleAndPortalUserDiffCreate
     * @request POST:/api/UserManager/MoodleAndPortalUserDiff
     * @secure
     */
    userManagerMoodleAndPortalUserDiffCreate: (
      data: FusionSharedEnumsUserCapabilityStatus[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/UserManager/MoodleAndPortalUserDiff`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  device = {
    /**
     * No description
     *
     * @tags Device
     * @name SetupCreate
     * @request POST:/Device/Setup
     * @secure
     */
    setupCreate: (
      data: BookingHandlersCommandsSetupCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/Device/Setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name GetByIdDetail
     * @request GET:/Device/GetById/{DeviceSetupID}
     * @secure
     */
    getByIdDetail: (deviceSetupId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Device/GetById/${deviceSetupId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name CheckSentryList
     * @request GET:/Device/CheckSentry
     * @secure
     */
    checkSentryList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Device/CheckSentry`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  l = {
    /**
     * No description
     *
     * @tags ShortenUrl
     * @name GetL
     * @request GET:/l/{shortenUrlToken}
     * @secure
     */
    getL: (shortenUrlToken: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/l/${shortenUrlToken}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  shortenUrlToken = {
    /**
     * No description
     *
     * @tags ShortenUrl
     * @name GetShortenUrlToken
     * @request GET:/{shortenUrlToken}
     * @secure
     */
    getShortenUrlToken: (shortenUrlToken: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${shortenUrlToken}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}
